<template>
  <div id="outer-container" class="company-details">
    <div class="settings-top-bar sticky-header">
      <div class="top-bar">
       <p>
          <a class="btn btn-orange btn-icon back" :title="$t('general.back')" @click.prevent="backButton">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
       </p>
       <p class="d-inline-flex">
          <a class="btn btn-danger btn-icon btn btn mar-rt-10 delete" v-if="id" @click.prevent="handleDelete">
            <img src="/static/img/icons/icon-close.png">
            {{$t('general.delete')}}
          </a>
          <button type="submit" class="btn btn-success btn-icon mar-rt-10 save" :disabled="loading || rSystemBusy || initialLoadError || !location" @click.prevent="validate" :title="$t('general.save') + ' ' + $t('settingUsers.single')">
            <img src="/static/img/icons/save.png">
            {{$t('general.save')}}
          </button>
        </p>
      </div>
    </div>

    <div ref="navButtons" class="card mar-bt-0 mar-to-10 max-z-index navButtons">
      <div class="card-content">
        <div class="clearfix row pad-lf-10 pad-rg-10 space-between">
          <a
            class="btn btn-fill"
            :class="[hasLocationErrors ? 'btn-danger' : 'btn-primary', currentSection === 'start' ? 'active' : '']"
            @click.prevent="openSection('start')"
          >{{$t('settingCompany.location')}}</a>
          <a
            class="btn btn-fill"
            :class="[hasDeliveryMethodsErrors ? 'btn-danger' : 'btn-primary', currentSection === 'delivery-methods' ? 'active' : '']"
            @click.prevent="openSection('delivery-methods')"
          >{{$t('general.deliveryMethod')}}</a>
          <!-- <a
            class="btn btn-fill btn-primary"
            :class="{ 'active': currentSection === 'import-menu-form' }"
            @click.prevent="openSection('import-menu-form')"
          >{{$t('upload.uploadMenuTemplateLabel')}}</a> -->
          <a
            v-if="displayIntegrationCard"
            class="btn btn-primary"
            :class="{ 'active': currentSection === 'import-integrations' }"
            @click.prevent="openSection('import-integrations')"
          >{{$t('settingCompany.menuIntegration')}}</a>
          <a
            class="btn btn-fill btn-primary"
            :class="[currentSection === 'menu-actions' ? 'active' : '']"
            @click.prevent="openSection('menu-actions')"
          >{{$t('settingCompany.menuActions')}}</a>
          <a
            class="btn btn-fill btn-primary"
            :class="{ 'active': currentSection === 'taxes' }"
            @click.prevent="openSection('taxes')"
          >{{$t('marketingCampaigns.Tax')}}</a>
          <a
            class="btn btn-fill"
            :class="[hasVatErrors ? 'btn-danger' : 'btn-primary', { 'active': currentSection === 'vat' }]"
            @click.prevent="openSection('vat')"
          >{{$t('catalogCateg.vatTitle')}}</a>
          <a
            class="btn btn-fill btn-primary"
            :class="{ 'active': currentSection === 'invoices' }"
            @click.prevent="openSection('invoices')"
          >{{$t('settingCompany.invoices')}}</a>
          <a
            class="btn btn-fill btn-primary"
            :class="{ 'active': currentSection === 'digital-waiter' }"
            @click.prevent="openSection('digital-waiter')"
          >{{$t('catalogProdOpt.menuQr')}}</a>
          <a
            class="btn btn-fill btn-primary"
            :class="{ 'active': currentSection === 'kiosk-qr-settings' }"
            @click.prevent="openSection('kiosk-qr-settings')"
          >{{$t('settingCompany.kioskQrSettingsTab')}}</a>
          <a
            class="btn btn-fill btn-primary"
            :class="{ 'active': currentSection === 'pos-settings' }"
            @click.prevent="openSection('pos-settings')"
          >{{$t('crossSell.posSettingsTab')}}</a>
          <a
            class="btn btn-fill"
            :class="[hasPaymentGroupErrors ? 'btn-danger' : 'btn-primary', currentSection === 'printer' ? 'active' : '']"
            @click.prevent="openSection('printer')"
          >{{$t('settingCompany.otherSettings')}}</a>
        </div>
      </div>
    </div>

    <div v-if="initialLoadError" class="alert alert-danger" role="alert">
      {{$t('validations.wentWrong')}}
      <button type="button" class="btn btn-sm btn-default" :disabled="loading" @click="loadLocationForm">
        {{$t('general.retry')}}
      </button>
    </div>

    <div :class="(loading ? 'show-loader' : 'hide-loader')">
      <div class="el-loading-spinner">
        <svg viewBox="25 25 50 50" class="circular">
          <circle cx="50" cy="50" r="20" fill="none" class="path"></circle>
        </svg>
      </div>
    </div>

    <div id="inner-container" ref="compDetailsContainer" v-if="location" class="company-wrap" :style="{height: windowHeight - pageTopHeight - navbarHeaderHeight - navButtonsHeight - 1 + 'px'}">
      <div v-show="currentSection === 'start'" id="start" class="card location-card">
        <div class="card-content">
          <form class="clearfix row">
            <div class="col-md-12">
              <h5>
                {{$t('settingCompany.bussLoc')}}: {{location.name}}
              </h5>
              <hr class="sm">
              <div class="col-md-6 pad-lf-0">
                <div class="form-group">
                  <label>{{$t('settingCompany.name')}}</label>
                  <input type="text" name="name" :placeholder="$t('settingCompany.name')" v-model="location.name" v-validate="modelValidate.name" class="form-control">
                </div>


                <div class="form-group">
                  <label>{{$t('settingCompany.email')}}</label>
                  <input type="text" name="email" :placeholder="$t('settingCompany.email')" v-model="location.email" v-validate="modelValidate.email" class="form-control">
                </div>

                <div class="form-group">
                  <label>{{$t('settingCompany.phone')}}</label>
                  <input type="text" name="phone" :placeholder="$t('settingCompany.phone')" v-model="location.phone" v-validate="modelValidate.phone" class="form-control">
                </div>

                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.country')}}</label>
                  <select v-model="location.country"
                          name="country"
                          class="select-primary form-control"
                          ref="country"
                          v-validate="modelValidate.country"
                          @change="updateCountry(location)">
                    <option v-for="country in countries"
                            class="select-primary"
                            :value="country.alpha2">{{country.name}}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.state')}}</label>
                  <template v-if="showStateDrop(location)">
                    <select v-model="location.state_id"
                            name="state"
                            class="select-primary form-control">
                      <option v-for="state in getStatesOptions(location)"
                            class="select-primary"
                            :value="state.id">{{state.name}}
                      </option>
                    </select>
                  </template>
                  <template v-else>
                    <input type="text" v-model="location.state" name="state"  class="form-control" v-validate="modelValidate.state">
                  </template>
                </div>

                <div class="form-group">
                  <label class="control-label">{{$t('settingCompany.city')}}</label>
                  <input type="text" v-model="location.city" name="city" :placeholder="$t('settingCompany.city')" class="form-control" v-validate="modelValidate.city">
                </div>

                <div class="col-md-8" style="padding: 0;">
                  <div class="form-group">
                    <label class="control-label">{{$t('settingCompany.street')}}</label>
                    <input type="text" v-model="location.street" name="street" :placeholder="$t('settingCompany.street')" class="form-control" v-validate="modelValidate.street">
                  </div>
                </div>

                <div class="col-md-4" style="padding-right: 0;">
                  <div class="form-group">
                    <label class="control-label">{{$t('settingCompany.number')}}</label>
                    <input type="text" v-model="location.number" name="street-number" v-validate="modelValidate.number" :placeholder="$t('settingCompany.number')" class="form-control" >
                  </div>
                </div>

                <div class="col-md-6" style="padding: 0;">
                  <div class="form-group">
                    <label class="control-label">{{$t('settingCompany.latitude')}}</label>
                    <input type="number" step="any" v-model="location.lat" name="lat" :placeholder="$t('settingCompany.latitude')" class="form-control">
                  </div>
                </div>

                <div class="col-md-6" style="padding-right: 0;">
                  <div class="form-group">
                    <label class="control-label">{{$t('settingCompany.longitude')}}</label>
                    <input type="number" step="any" v-model="location.lng" name="lng" :placeholder="$t('settingCompany.longitude')" class="form-control">
                  </div>
                </div>
              </div>

              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6 no-padding">
                    <image-input
                      :location="location"
                      :label="$t('settingCompany.locationImage')"
                      :image="location.image"
                      imageField="image"
                      style="margin-bottom: 30px"
                    />
                  </div>
                  <div v-if="location.app_link" class="col-md-6 no-padding">
                    <display-qr-app
                      :location="location"
                    />
                  </div>
                </div>

                <div class="col-md-6 no-padding">
                  <image-input
                    :location="location"
                    :label="$t('general.logo')"
                    :image="location.dynamic_menu_logo"
                    imageField="dynamic_menu_logo"
                  />
                </div>

                <div class="col-md-6 no-padding">
                  <image-input
                    :location="location"
                    :label="$t('marketingOffers.banners')"
                    :image="location.dynamic_menu_banner"
                    imageField="dynamic_menu_banner"
                  />
                </div>


                <div class="col-md-8 no-padding" v-if="location.true_id">
                  <label>{{$t('settingCompany.authAppCode')}}</label>
                  <br>
                  <button class="btn" @click.prevent="generateCode()">{{$t('settingCompany.generateAuthAppCode')}}</button>
                  <br>
                  <br>
                  <input v-if="location.auth_code" type="text" disabled :value="location.auth_code">
                  <button v-if="location.auth_code" class="btn btn-info btn-icon duplicate-prod" @click.prevent="copy(location.auth_code)"><i class="fa fa-copy"/></button>
                  <div class="form-group" v-if="location.auth_qr_code">
                    <template>
                      <div class="col-md-12 px-0">
                        <img style="height: 170px; width:170px;" v-bind:src="location.auth_qr_code">
                        <a class="btn btn-info btn-icon duplicate-prod" :href="location.auth_qr_code" target="_blank"><i class="fa fa-download"/></a>
                      </div>
                    </template>
                  </div>
                </div>

              </div>
            </div>


            <div class="col-md-12">
              <br>
              <h5 style="margin-bottom: 0;">
                Date Facturare
              </h5>
              <span style="font-size: 12px; font-weight: 400;">Aceste date se folosesc la facturare si gestiune</span>
              <hr class="sm">
              <div class="col-md-6 pad-lf-0">
                <div class="form-group">
                  <label>{{$t('settingCompany.inv_company_name')}}</label>
                  <input type="text" name="inv_company_name" :placeholder="$t('settingCompany.inv_company_name')" v-model="location.inv_company_name" v-validate="modelValidate.inv_company_name" class="form-control">
                </div>

                <div class="form-group">
                  <label>{{$t('settingCompany.inv_fiscal_code ')}}</label>
                  <input type="text" name="inv_fiscal_code " :placeholder="$t('settingCompany.inv_fiscal_code')" 
                    :disabled="inv_fiscal_code_disabled_field"
                    v-model="location.inv_fiscal_code " v-validate="modelValidate.inv_fiscal_code " class="form-control">
                </div>

                <div class="form-group">
                  <label>{{$t('settingCompany.inv_trade_register')}}</label>
                  <input type="text" name="inv_trade_register" :placeholder="$t('settingCompany.inv_trade_register')" v-model="location.inv_trade_register" v-validate="modelValidate.inv_trade_register" class="form-control">
                </div>

                <div class="form-group">
                  <label>{{$t('settingCompany.inv_phone')}}</label>
                  <input type="text" name="inv_phone" :placeholder="$t('settingCompany.inv_phone')" v-model="location.inv_phone" v-validate="modelValidate.inv_phone" class="form-control">
                </div>

                <div class="form-group">
                  <label>{{$t('settingCompany.inv_email')}}</label>
                  <input type="text" name="inv_email" :placeholder="$t('settingCompany.inv_email')" v-model="location.inv_email" v-validate="modelValidate.inv_email" class="form-control">
                </div>

                <div class="form-group">
                  <label>{{$t('settingCompany.inv_bank_account')}}</label>
                  <input type="text" name="inv_bank_account" :placeholder="$t('settingCompany.inv_bank_account')" v-model="location.inv_bank_account" class="form-control">
                </div>

                <div class="form-group">
                  <label>{{$t('settingCompany.inv_bank')}}</label>
                  <input type="text" name="inv_bank" :placeholder="$t('settingCompany.inv_bank')" v-model="location.inv_bank" class="form-control">
                </div>

                <div class="form-group">
                  <label>{{$t('settingCompany.inv_bank_branch')}}</label>
                  <input type="text" name="inv_bank_branch" :placeholder="$t('settingCompany.inv_bank_branch')" v-model="location.inv_bank_branch" class="form-control">
                </div>

              </div>

              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('settingCompany.inv_country')}}</label>
                      <select 
                        class="select-primary form-control" 
                        v-model="location.inv_country"
                        @change="onCountryChange">
                        <option value="">{{$t('settingCompany.inv_country')}}</option>
                        <option 
                          v-for="country in countriesList" 
                          :key="country.name" 
                          :value="country.name">
                          {{country.name}}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('settingCompany.inv_county')}}</label>
                      <!-- Selector pentru județ dacă țara are counties -->
                      <select 
                        v-if="selectedCountry && selectedCountry.counties.length > 0"
                        class="select-primary form-control"
                        v-model="location.inv_county">
                        <option value="">{{$t('settingCompany.inv_county')}}</option>
                        <option 
                          v-for="county in selectedCountry.counties" 
                          :key="county.code" 
                          :value="county.name">
                          {{county.name}}
                        </option>
                      </select>
                      <!-- Input text pentru județ dacă țara nu are counties -->
                      <input 
                        v-else
                        type="text" 
                        name="inv_county" 
                        :placeholder="$t('settingCompany.inv_county')" 
                        v-model="location.inv_county" 
                        v-validate="modelValidate.inv_county" 
                        class="form-control">
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>{{$t('settingCompany.inv_city')}}</label>
                  <input type="text" name="inv_city" :placeholder="$t('settingCompany.inv_city')" v-model="location.inv_city" v-validate="modelValidate.inv_city" class="form-control">
                </div>

                <div class="row">
                  <div class="col-md-8">
                    <div class="form-group">
                      <label>{{$t('settingCompany.inv_address')}}</label>
                      <input type="text" name="inv_address" :placeholder="$t('settingCompany.inv_address')" v-model="location.inv_address" v-validate="modelValidate.inv_address" class="form-control">
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="form-group">
                      <label>{{$t('settingCompany.inv_street_number')}}</label>
                      <input type="text" name="inv_street_number" :placeholder="$t('settingCompany.inv_street_number')" v-model="location.inv_street_number" v-validate="modelValidate.inv_street_number" class="form-control">
                    </div>
                  </div>
                </div>

                <div class="form-group">
                  <label>{{$t('settingCompany.inv_additional_data')}}</label>
                  <input type="text" name="inv_additional_data" :placeholder="$t('settingCompany.inv_additional_data')" v-model="location.inv_additional_data" v-validate="modelValidate.inv_additional_data" class="form-control">
                </div>

                <div class="form-group">
                  <label>{{$t('settingCompany.inv_is_vat_payer')}}</label>
                  <br>
                  <select class="select-primary form-control inline-auto"
                            ref="inv_is_vat_payer" style="width: 100%;" v-model="location.inv_is_vat_payer">
                        <option
                                class="select-primary"
                                :value="0">{{$t('settingCompany.inv_is_vat_payer_0')}}
                        </option>
                        <option
                                class="select-primary"
                                :value="1">{{$t('settingCompany.inv_is_vat_payer_1')}}
                        </option>
                    </select>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div v-show="currentSection === 'delivery-methods'" id="delivery-methods" class="card location-card">
        <div class="card-content">
          <form class="clearfix row">
            <div class="col-md-12">
              <div class="form-group">
                <h5>{{$t('settingsPages.deliveryMethods')}}</h5>
                <hr class="sm">
                <delivery-methods
                  :modeldata="location"
                  :defaultData="defaultData"
                  @mapactive="updateLocationMapActive"
                  ref="deliveryMethods"
                ></delivery-methods>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- <div v-show="currentSection === 'import-menu-form'" id="import-menu-form" class="card location-card">
        <div class="card-content">
          <form class="clearfix row">
            <div class="col-md-12">
              <div class="form-group">
                <h5>{{ $t('upload.uploadMenuTemplateLabel') }}</h5>
                <hr class="sm">
                <div class="col-md-6">
                  <label for="download" class="pad-bt-5">{{ $t('upload.downloadImportProductsTemplate') }}</label>
                  <br>
                  <a name="download" :href="apiUrl + 'download-import-form?token=' + $session.get('token')" target="_blank">
                    <el-button size="small" class="btn add" type="primary" @click="downloadForm()">{{ $t('upload.downloadButton') }}</el-button>
                  </a>
                </div>
                <div class="col-md-6">
                  <div class="row">
                    <div class="col-md-6">
                      <archive-input
                        :location="location"
                      ></archive-input>
                    </div>
                    <div class="col-md-6">
                      <import-products-input
                        :location="location"
                      ></import-products-input>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div> -->

     <div v-show="currentSection === 'import-integrations'" id="import-integrations" v-if="displayIntegrationCard">
        <div class="card location-card" v-if="location.is_magister_location">
          <div class="card-content">
            <form class="clearfix row">
              <div class="col-md-12">
              <div class="form-group">
                <h5>{{ $t('magister.syncLabel') }}</h5>
                <hr class="sm">
                <div class="row">
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-6">
                        <label for="download" class="pad-bt-5">{{ $t('magister.syncPrices') }}</label>
                        <br>
                        <el-button size="small" class="btn add" type="primary" @click.prevent="updateProductPricesMagister(location)">{{ $t('general.start') }}</el-button>
                      </div>
                      <div class="col-md-6">
                        <label for="download" class="pad-bt-5">{{ $t('magister.syncStocks') }}</label>
                        <br>
                        <el-button size="small" class="btn add" type="primary" @click.prevent="updateProductStocksMagister(location)">{{ $t('general.start') }}</el-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card location-card" v-if="location.is_tazz_location">
          <div class="card-content">
            <form class="clearfix row">
              <div class="col-md-12">
                <div class="form-group">
                  <h5>{{ $t('tazz.syncLabel') }}</h5>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <el-button size="small" class="btn add" type="primary" @click.prevent="updateTazzMenu(location)">{{ $t('general.start') }}</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card location-card" v-if="location.is_rkeeper_location">
          <div class="card-content">
            <form class="clearfix row">
              <div class="col-md-12">
                <div class="form-group">
                  <h5>{{ $t('rkeeper.sync') }}</h5>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-4">
                          <el-button size="small" class="btn add" type="primary" @click.prevent="importCategories(location)">{{ $t('rkeeper.categories') }}</el-button>
                          <el-button size="small" class="btn add" type="primary" @click.prevent="importProducts(location)">{{ $t('rkeeper.products') }}</el-button>
                        </div>
                        <div class="col-md-4">
                          <el-button size="small" class="btn add" type="primary" @click.prevent="importProducts(location, 1)">{{ $t('rkeeper.onlyProducts') }}</el-button>
                          <el-button size="small" class="btn add" type="primary" @click.prevent="importProducts(location, 2)">{{ $t('rkeeper.onlyOptions') }}</el-button>
                        </div>
                        <div class="col-md-4">
                          <el-button size="small" class="btn add" type="primary" @click.prevent="syncProductPrices(location)">{{ $t('rkeeper.productPrices') }}</el-button>
                          <el-button size="small" class="btn add" type="primary" @click.prevent="syncOptionPrices(location)">{{ $t('rkeeper.optionPrices') }}</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card location-card" v-if="ensureRkV2(location)">
          <div class="card-content">
            <form class="clearfix row">
              <div class="col-md-12">
                <div class="form-group">
                  <h5>{{ $t('rkeeperV2.title') }}</h5>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <label>{{ $t('rkeeperV2.url') }}</label>
                      <input type="text" class="form-control" v-model="location.rkeeper_v2.url" :disabled="location.rkeeper_v2.active">
                    </div>
                    <div class="col-md-6">
                      <label>{{ $t('rkeeperV2.slug') }}</label>
                      <input type="text" class="form-control" v-model="location.rkeeper_v2.restaurant_slug" :disabled="location.rkeeper_v2.active">
                    </div>
                  </div>
                  <div class="row" style="margin-top: 10px;">
                    <div class="col-md-4">
                      <label>{{ $t('rkeeperV2.apiUser') }}</label>
                      <input type="text" class="form-control" v-model="location.rkeeper_v2.api_user" :disabled="location.rkeeper_v2.active">
                    </div>
                    <div class="col-md-4">
                      <label>{{ $t('rkeeperV2.apiSecret') }}</label>
                      <input type="text" class="form-control" v-model="location.rkeeper_v2.api_secret" :disabled="location.rkeeper_v2.active">
                    </div>
                    <div class="col-md-4">
                      <label>&nbsp;</label>
                      <div>
                        <el-button size="small" class="btn add" type="info" :loading="location.rkeeper_v2.testing" @click.prevent="testRkV2Login(location)">{{ $t('rkeeperV2.testLogin') }}</el-button>
                        <el-button size="small" class="btn add" type="primary" :loading="location.rkeeper_v2.saving" :disabled="location.rkeeper_v2.active" @click.prevent="saveRkV2(location)">{{ $t('rkeeperV2.save') }}</el-button>
                      </div>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 10px;">
                    <div class="col-md-4">
                      <label class="checkbox-inline">
                        <input type="checkbox" v-model="location.rkeeper_v2.active" @change="toggleRkV2Active(location)" :disabled="!location.rkeeper_v2.login_ok && !location.rkeeper_v2.active"> {{ $t('rkeeperV2.active') }}
                      </label>
                    </div>
                    <div class="col-md-8" v-if="location.rkeeper_v2.login_message">
                      <span :class="location.rkeeper_v2.login_ok ? 'text-success' : 'text-danger'">{{ location.rkeeper_v2.login_message }}</span>
                    </div>
                  </div>
                  <div class="row" style="margin-top: 10px;" v-if="location.rkeeper_v2.active">
                    <div class="col-md-4">
                      <el-button size="small" class="btn add" type="primary" :loading="location.rkeeper_v2.is_running" :disabled="location.rkeeper_v2.is_running" @click.prevent="syncRkV2Menu(location)">{{ $t('rkeeperV2.syncMenu') }}</el-button>
                    </div>
                    <div class="col-md-8" v-if="location.rkeeper_v2.sync_message">
                      <span>{{ location.rkeeper_v2.sync_message }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card location-card" v-if="location.glovo_company_id">
          <div class="card-content">
            <form class="clearfix row">
              <div>
                <div class="form-group col-md-12">
                  <h5>Glovo</h5>
                  <hr class="sm">

                  <div class="form-group col-md-12">
                    <div class="row" style="margin-bottom: 20px;">
                      <div class="col-md-1">
                        <label>{{$t('bolt.menu')}}</label>
                      </div>
                      <div class="col-md-2" style="display: flex; align-items: center;">
                        <button
                          class="btn add"
                          @click.prevent="updateGlovoMenu()"
                          :title="$t('general.update')"
                        >
                          <!-- <img src="/static/img/icons/add.png"> -->
                          {{$t('general.update')}}
                        </button>
                      </div>
                    </div>
                  </div>

                  <p-switch v-model="glovoStatus" type="success" class="mar-bt-0" name="bolt-orders" @input="handleGlovoStatus()"></p-switch>
                  <label for="bolt-orders">{{ $t('bolt.acceptOrders') }}</label>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card location-card" v-if="location.freya_cloud_id">
          <div class="card-content">
            <form class="clearfix row">
              <div class="col-md-12">
                <div class="form-group">
                  <!-- <h6>{{ $t('glovo.syncLabel') }}</h6> -->
                  <h5>Freya Cloud Import</h5>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <el-button size="small" class="btn add" type="primary" @click.prevent="syncFreyaCloudMenu(location)">{{ $t('general.start') }}</el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card location-card" v-if="location.ep_restaurant_id">
          <div class="card-content">
            <form class="clearfix row">
              <div class="col-md-12">
                <div class="form-group">
                  <h5>{{ $t('epRestaurant.importLabel') }}</h5>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <el-button size="small" class="btn add" type="primary" @click.prevent="syncEpRestaurantMenu(location)">
                            {{ $t('epRestaurant.importButton') }}
                          </el-button>
                          <el-button size="small" class="btn add" type="primary" @click.prevent="syncEpRestaurantMenu(location, true)">
                            {{ $t('epRestaurant.syncButton') }}
                          </el-button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card location-card" v-if="location.nexus_id">
          <div class="card-content">
            <form class="clearfix row">
              <div class="col-md-12">
                <div class="form-group">
                  <h5>NEXUS</h5>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6 datetime-picker pull-left">
                      <label for="orders-period">{{$t('nexus.ordersPeriod')}}</label>
                      <br>
                      <el-date-picker
                        id="orders-period"
                        v-model="nexusFrom"
                        type="datetime"
                        placeholder="Select From Date & Time"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                      >
                      </el-date-picker>
                      -
                      <el-date-picker
                        v-model="nexusTo"
                        type="datetime"
                        placeholder="Select To Date & Time"
                        format="yyyy-MM-dd HH:mm"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        :picker-options="pickerOptions"
                        @change="handleNexusToChange"
                      >
                      </el-date-picker>
                      <span class="help-block"><i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('nexus.elgibleOrders')}} <br> {{$t('nexus.ordersAlreadyIntegrated')}}</span>
                    </div>
                    <!-- <div class="col-md-6">

                    </div> -->
                  </div>
                  <div class="row">
                    <div class="col-md-6 datetime-picker pull-left">
                      <el-button size="small" class="btn add" type="primary" @click.prevent="createNexusOrders" :disabled="!isNexusDatesValid">
                        {{ $t('general.load') }}
                      </el-button>
                      <el-button size="small" class="btn add" type="primary" @click.prevent="cancelNexusOrders" :disabled="!isNexusDatesValid">
                        {{ $t('general.cancel') }}
                      </el-button>
                      <el-button size="small" class="btn add" type="primary" @click.prevent="retryFailedOrders" :disabled="!isNexusDatesValid">
                        {{ $t('general.retry') }}
                      </el-button>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card location-card" v-if="location.wolt_company_id">
          <div class="card-content">
            <form class="clearfix row">
              <div>
                <div class="form-group col-md-12">
                  <h5>Wolt</h5>
                  <hr class="sm">

                  <span v-if="!location.wolt_is_integrated">
                    <label for="getOntoWolt" class="pad-bt-5">{{ $t('wolt.integrateLocation') }}</label>
                    <div name="getOntoWolt">
                      <el-button size="small" class="btn add" type="primary" @click="redirectToWolt()">{{ $t('wolt.getWolt') }}</el-button>
                    </div>
                  </span>

                  <div v-if="location.wolt_is_integrated" class="form-group col-md-12">
                    <div class="row" style="margin-bottom: 20px;">
                      <div class="col-md-1">
                        <label>{{$t('bolt.menu')}}</label>
                      </div>
                      <div class="col-md-2" style="display: flex; align-items: center;">
                        <button
                          class="btn add"
                          @click.prevent="updateWoltMenu()"
                          :title="$t('general.update')"
                        >
                          <!-- <img src="/static/img/icons/add.png"> -->
                          {{$t('general.update')}}
                        </button>
                      </div>
                    </div>
                    <div class="row" style="margin-bottom: 20px;">
                      <div class="col-md-1">
                        <label>{{$t('wolt.updateCredentials')}}</label>
                      </div>
                      <div class="col-md-2" style="display: flex; align-items: center;">
                        <button
                          class="btn add"
                          @click.prevent="redirectToWolt()"
                          :title="$t('wolt.updateCredentials')"
                        >
                          <!-- <img src="/static/img/icons/add.png"> -->
                          {{$t('wolt.redirectToWolt')}}
                        </button>
                      </div>
                    </div>
                    <div class="row" style="margin-bottom: 20px;">
                      <div class="col-md-1">
                        <label>{{$t('settingsOrdering.available_days')}}</label>
                      </div>
                      <div class="col-md-2" style="display: flex; align-items: center;">
                        <button
                          class="btn add"
                          @click.prevent="updateWoltSchedule()"
                          :title="$t('general.update')"
                        >
                          <!-- <img src="/static/img/icons/add.png"> -->
                          {{$t('general.update')}}
                        </button>
                      </div>
                    </div>
                    <div
                      class="row"
                      v-for="(day, dayIdx) in woltSchedule"
                      :key="dayIdx"
                      style="display: flex; align-items: flex-start; margin-bottom: 20px;"
                    >
                      <div class="col-md-8">
                        <div class="row">
                          <div class="col-md-3 padd in-inline-160">
                            <div class="checkbox">
                              <input
                                type="checkbox"
                                v-model="day.open"
                                :name="`day-checkbox-${dayIdx}`"
                                :id="`day-checkbox-${dayIdx}`"
                              />
                              <label :for="`day-checkbox-${dayIdx}`">
                                {{$t('days.' + dayIdx) | capitalize}}
                              </label>
                            </div>
                          </div>
                          <div class="col-md-9 padd">
                            <template v-for="(interval, intervalKey) in day.intervals">
                              <!-- <div class="col-md-3 padd in-inline-160"></div> -->
                              <div class="col-md-9 padd">
                                {{ $t('menuLink.from') }}
                                <el-time-select
                                  :disabled="!day.open"
                                  placeholder="Start time"
                                  v-model="interval.opening_time"
                                  :picker-options="pickerOptions"
                                  style="width: 150px; display: inline-block; vertical-align: middle;"
                                />
                                {{ $t('menuLink.to') }}
                                <el-select
                                  :disabled="!day.open"
                                  placeholder="End time"
                                  v-model="interval.closing_time"
                                  filterable
                                  style="width: 150px; display: inline-block; vertical-align: middle;">
                                  <el-option
                                    v-for="time in boltEndTimeOptions"
                                    :key="'wolt-end-time-' + time"
                                    :label="time"
                                    :value="time" />
                                </el-select>
                                <button
                                  v-if="intervalKey != 0"
                                  class="btn btn-simple btn-icon"
                                  @click.prevent="deleteWoltIntervals(intervalKey, dayIdx)"
                                >
                                  <i class="ti-close text-danger" :title="$t('general.delete')"></i>
                                </button>
                              </div>
                            </template>
                            <button
                              class="btn add"
                              @click.prevent="addMoreWoltIntervals(dayIdx)"
                              :title="$t('general.add') + ' moreIntervals'"
                              style="margin-left: 10px;"
                            >
                              <img src="/static/img/icons/add.png">
                              {{$t('general.add')}}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <p-switch v-if="location.wolt_is_integrated" v-model="woltStatus" type="success" class="mar-bt-0" name="wolt-orders" @input="handleWoltStatus()"></p-switch>
                  <label v-if="location.wolt_is_integrated" for="wolt-orders">{{ $t('bolt.acceptOrders') }}</label>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card location-card" v-if="location.bolt_company_id">
          <div class="card-content">
            <form class="clearfix row">
              <div>
                <div class="form-group col-md-12">
                <h5>Bolt Food</h5>
                <hr class="sm">


                <div class="form-group col-md-12">
                  <div class="row" style="margin-bottom: 20px;">
                    <div class="col-md-1">
                      <label>{{$t('bolt.menu')}}</label>
                    </div>
                    <div class="col-md-2" style="display: flex; align-items: center;">
                      <button
                        class="btn add"
                        @click.prevent="updateBoltMenu()"
                        :title="$t('general.update')"
                      >
                        <!-- <img src="/static/img/icons/add.png"> -->
                        {{$t('general.update')}}
                      </button>
                    </div>
                  </div>
                  <div class="row" style="margin-bottom: 20px;">
                    <div class="col-md-1">
                      <label>{{$t('settingsOrdering.available_days')}}</label>
                    </div>
                    <div class="col-md-2" style="display: flex; align-items: center;">
                      <button
                        class="btn add"
                        @click.prevent="updateBoltSchedule()"
                        :title="$t('general.update')"
                      >
                        <!-- <img src="/static/img/icons/add.png"> -->
                        {{$t('general.update')}}
                      </button>
                    </div>
                  </div>
                  <div
                    class="row"
                    v-for="(day, dayIdx) in boltSchedule"
                    :key="dayIdx"
                    style="display: flex; align-items: flex-start; margin-bottom: 20px;"
                  >
                    <div class="col-md-8">
                      <div class="row">
                        <div class="col-md-3 padd in-inline-160">
                          <div class="checkbox">
                            <input
                              type="checkbox"
                              v-model="day.open"
                              :name="`day-checkbox-${dayIdx}`"
                              :id="`day-checkbox-${dayIdx}`"
                            />
                            <label :for="`day-checkbox-${dayIdx}`">
                              {{$t('days.' + dayIdx) | capitalize}}
                            </label>
                          </div>
                        </div>
                        <div class="col-md-9 padd">
                          <template v-for="(interval, intervalKey) in day.intervals">
                            <!-- <div class="col-md-3 padd in-inline-160"></div> -->
                            <div class="col-md-9 padd">
                              {{ $t('menuLink.from') }}
                              <el-time-select
                                :disabled="!day.open"
                                placeholder="Start time"
                                v-model="interval.start_at_minutes_from_midnight"
                                :picker-options="pickerOptions"
                                style="width: 150px; display: inline-block; vertical-align: middle;"
                              />
                              {{ $t('menuLink.to') }}
                              <el-select
                                :disabled="!day.open"
                                placeholder="End time"
                                v-model="interval.stop_at_minutes_from_midnight"
                                filterable
                                style="width: 150px; display: inline-block; vertical-align: middle;">
                                <el-option
                                  v-for="time in boltEndTimeOptions"
                                  :key="'bolt-end-time-' + time"
                                  :label="time"
                                  :value="time" />
                              </el-select>
                              <button
                                v-if="intervalKey != 0"
                                class="btn btn-simple btn-icon"
                                @click.prevent="deleteBoltIntervals(intervalKey, dayIdx)"
                              >
                                <i class="ti-close text-danger" :title="$t('general.delete')"></i>
                              </button>
                            </div>
                          </template>
                          <button
                            class="btn add"
                            @click.prevent="addMoreBoltIntervals(dayIdx)"
                            :title="$t('general.add') + ' moreIntervals'"
                            style="margin-left: 10px;"
                          >
                            <img src="/static/img/icons/add.png">
                            {{$t('general.add')}}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <p-switch v-model="boltStatus" type="success" class="mar-bt-0" name="bolt-orders" @input="handleBoltStatus()"></p-switch>
                <label for="bolt-orders">{{ $t('bolt.acceptOrders') }}</label>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card location-card">
          <div class="card-content">
            <form class="clearfix row">
              <div>
                <div class="form-group col-md-12">
                  <h5>R System</h5>
                  <hr class="sm">
                  <r-system-setup ref="rSystemSetup" :location="location" @busy="rSystemBusy = $event" @saved="$set(location, 'r_system_company', $event)" />
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="card location-card">
          <div class="card-content">
            <form class="clearfix row">
              <div>
                <div class="form-group col-md-12">
                  <h5>{{ $t('ebriza.title') }}</h5>
                  <hr class="sm">
                  <div class="form-group col-md-12">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="mb-3 w-100 mar-bt-15">
                          <label>{{ $t('ebriza.woltDriveErrorsUrl') }}</label>
                          <input
                            type="text"
                            name="wolt_drive_errors_url"
                            placeholder="https://ebriza.ro/send/logs/here"
                            v-model="location.wolt_drive_errors_url"
                            class="form-control">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <!-- Posnet -->
        <div class="card location-card" v-if="location.posnet_company_id">
          <div class="card-content">
            <form class="clearfix row">
              <div>
                <div class="form-group col-md-12" style="margin-bottom: 0px !important;">
                  <h5>Posnet</h5>
                  <hr class="sm">
                </div>

                <div class="form-group col-md-12" style="display: flex; align-items: center; gap: 15px;">
                  <div class="col-md-4" style="display: flex; align-items: center; padding-left: 0;">
                  <p-switch
                    v-model="location.posnet_company_show_report"
                    type="success"
                    class="mar-bt-0"
                    name="posnet-report"
                    @input="handlePosnetReportToggle"
                  ></p-switch>
                    <label style="margin-bottom: 0; margin-left: 8px;">{{$t('posnet.enableReport')}}</label>
                  </div>
                  <div class="col-md-4" style="display: flex; align-items: center; padding-left: 0;">
                    <label style="margin-bottom: 0; margin-right: 8px;">{{$t('posnet.reportDate')}}</label>
                    <el-date-picker
                      v-model="location.posnet_company_report_date"
                      type="date"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd"
                      clearable
                      @change="handlePosnetDateChange"
                      @focus="handlePosnetDateFocus"
                      @visible-change="handlePosnetDateVisible"
                      style="flex: 1;"
                    >
                    </el-date-picker>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

      </div>

      <div v-show="currentSection === 'menu-actions'" id="menu-actions">
        <div class="card location-card">
          <div class="card-content">
            <form class="clearfix row">
              <div class="col-md-12">
                <div class="form-group">
                  <div class="flex-container">
                    <h5>{{ $t('upload.uploadMenuTemplateLabel') }}</h5>
                    <button
                      v-if="location && location.true_id"
                      type="button"
                      class="btn btn-info import-history-btn"
                      @click="openImportHistory"
                    >
                      <i class="ti-list"></i>
                      {{ $t('productImport.importHistory') }}
                    </button>
                  </div>
                  <hr class="sm">
                  <div class="row import-steps">
                    <div class="col-md-3 col-sm-6 col-xs-12 mar-bt-15 import-step">
                      <div class="import-step__head">
                        <span class="import-step__badge">1</span>
                        <strong>{{ $t('productImport.step1Title') }}</strong>
                      </div>
                      <div class="import-step__body">
                        <p class="import-step__hint text-muted">{{ $t('productImport.step1Intro') }}</p>

                        <div class="import-option">
                          <div class="import-option__label">{{ $t('productImport.optionEmptyTitle') }}</div>
                          <p class="import-option__desc text-muted">{{ $t('productImport.optionEmptyDesc') }}</p>
                          <a name="download" :href="downloadImportHref" target="_blank">
                            <button
                              type="button"
                              class="btn btn-info import-step__btn"
                              @click="downloadForm()"
                            >{{ $t('productImport.downloadEmptyForm') }}</button>
                          </a>
                        </div>

                        <div class="import-option import-option--secondary">
                          <div class="import-option__label">{{ $t('productImport.optionExportTitle') }}</div>
                          <p class="import-option__desc text-muted">{{ $t('productImport.optionExportDesc') }}</p>
                          <label class="pad-bt-5">{{ $t('productImport.selectPriceProfile') }}</label>
                          <el-select
                            v-model="selectedPriceProfileId"
                            clearable
                            filterable
                            :placeholder="$t('productImport.selectPriceProfile')"
                            style="width:100%;"
                            :disabled="creatingDefaultPriceProfile"
                          >
                            <el-option
                              v-for="profile in locationPriceProfiles"
                              :key="profile.id"
                              :label="profile.name"
                              :value="profile.id"
                            />
                          </el-select>
                          <p class="import-option__note text-muted">{{ $t('productImport.defaultPriceListHint') }}</p>
                          <div class="import-option__actions" style="display:flex;align-items:center;flex-wrap:nowrap;gap:8px;">
                            <a
                              v-if="canExportProducts"
                              :href="exportProductsHref"
                              target="_blank"
                            >
                              <button type="button" class="btn btn-info import-step__btn">{{ $t('productImport.exportProducts') }}</button>
                            </a>
                            <button
                              v-else
                              type="button"
                              class="btn btn-info import-step__btn"
                              disabled
                              :title="exportDisabledReason"
                            >{{ $t('productImport.exportProducts') }}</button>
                            <a
                              v-if="canExportImages"
                              :href="exportImagesHref"
                              target="_blank"
                            >
                              <button type="button" class="btn btn-info import-step__btn" style="font-size:12px;padding:4px 10px;">{{ $t('productImport.exportImages') }}</button>
                            </a>
                            <button
                              v-else
                              type="button"
                              class="btn btn-info import-step__btn"
                              style="font-size:12px;padding:4px 10px;"
                              disabled
                              :title="exportImagesDisabledReason"
                            >{{ $t('productImport.exportImages') }}</button>
                          </div>
                          <p
                            v-if="!locationHasProducts"
                            class="import-option__note text-muted"
                          >{{ $t('productImport.noProductsForExport') }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 mar-bt-15 import-step">
                      <div class="import-step__head">
                        <span class="import-step__badge">2</span>
                        <strong>{{ $t('productImport.step2Title') }}</strong>
                      </div>
                      <div class="import-step__body">
                        <p class="text-muted" style="margin:0;">{{ $t('productImport.step2Body') }}</p>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 mar-bt-15 import-step">
                      <div class="import-step__head">
                        <span class="import-step__badge">3</span>
                        <strong>{{ $t('productImport.step3Title') }}</strong>
                      </div>
                      <div class="import-step__body">
                        <p class="import-step__hint text-muted">{{ $t('productImport.step3Hint') }}</p>
                        <archive-input
                          :location="location"
                        ></archive-input>
                      </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-xs-12 mar-bt-15 import-step">
                      <div class="import-step__head">
                        <span class="import-step__badge">4</span>
                        <strong>{{ $t('productImport.step4Title') }}</strong>
                      </div>
                      <div class="import-step__body">
                        <p class="import-step__hint text-muted">{{ $t('productImport.step4Hint') }}</p>
                        <import-products-input
                          :location="location"
                        ></import-products-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="card location-card">
          <div class="card-content">
            <form class="clearfix row">
              <div class="col-md-12">
                <div class="form-group">
                  <h5>{{ $t('productImport.legacyTitle') }}</h5>
                  <hr class="sm">
                  <!-- <p class="text-muted" style="margin:0 0 12px;font-size:13px;line-height:1.4;">
                    {{ $t('productImport.legacyHint') }}
                  </p> -->
                  <div class="col-md-6">
                    <label for="download-legacy" class="pad-bt-5">{{ $t('upload.downloadImportProductsTemplate') }}</label>
                    <br>
                    <a
                      name="download-legacy"
                      :href="downloadLegacyImportHref"
                      target="_blank"
                    >
                      <el-button
                        size="small"
                        class="btn add"
                        type="primary"
                      >{{ $t('upload.downloadButton') }}</el-button>
                    </a>
                  </div>
                  <div class="col-md-6">
                    <div class="row">
                      <div class="col-md-6">
                        <archive-input
                          :location="location"
                        ></archive-input>
                      </div>
                      <div class="col-md-6">
                        <import-products-legacy-input
                          :location="location"
                        ></import-products-legacy-input>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>

        <div class="card-containerf1">
          <div class="card location-card width-50">
            <div class="card-content">
              <form class="clearfix row">
                <div class="col-md-12">
                  <h5>{{$t('settingCompany.menuActions')}}</h5>
                  <hr class="sm">
                  <template v-if="allLocations.length > 1">
                    {{$t('settingCompany.copyProductsFrom')}}
                    <select class="select-primary form-control inline-auto mar-lt-5"
                            ref="copyFrom">
                      <template v-for="l in allLocations">
                        <option v-if="l.id !== location.id"
                                class="select-primary"
                                :value="l.id">{{l.name}}
                        </option>
                      </template>
                    </select>
                    <button class="btn btn-info btn-icon duplicate-prod mar-to--5 mar-lt-5"
                      @click.prevent="copyProducts()"><i class="fa fa-copy"></i>
                    </button>
                    <button class="btn btn-info btn-icon duplicate-prod mar-to--5 mar-lt-5"
                      @click.prevent="addLocationToProducts()">{{$t('settingCompany.copyBtn')}}</i>
                    </button>
                    <br>
                    <br>
                  </template>
                  {{$t('settingCompany.deleteProducts')}}
                  <a
                    class="btn delete mar-rt-10"
                    :title="$t('general.delete')"
                    @click.prevent="deleteProducts(location.id)">
                    <img src="/static/img/icons/icon-close.png">
                    {{$t('general.delete')}}
                  </a>
                </div>
              </form>
            </div>
          </div>
          <div class="width-50"></div>
        </div>
      </div>

      <div v-show="currentSection === 'taxes'" id="taxes" class="card location-card">
        <div class="card-content">
          <form class="clearfix row">
            <div class="col-md-12">
              <div class="form-group">
                <h5>{{$t('vat.generalTaxes')}}</h5>
                <hr class="sm">
                <table class="table mar-bt-0">
                  <thead>
                    <tr>
                      <th>{{$t('settingTaxes.single')}}</th>
                      <th>{{$t('settingTaxes.type')}}</th>
                      <th>{{$t('settingTaxes.amount')}}</th>
                      <th style="padding-left: 55px">{{$t('catalogProdOpt.posid')}}</th>
                      <th style="padding-left: 55px">{{$t('general.tips_department_id')}}</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(taxRate, taxIndex) in location.taxes">
                      <td>
                        <select
                          @input="updateVatPrinterId($event, taxIndex)"
                          v-model="taxRate.id"
                          class="form-control"
                          v-validate="{required: true}" >
                          <option
                            v-for="tax in taxes"
                            :value="tax.id"
                            :data-name="tax.name"
                            :disabled="disableTaxOption(location.id, tax.id) && tax.id != taxRate.id"
                            >{{tax.name}}
                          </option>
                        </select>
                          <!--   <input type="text"
                                  min="0"
                                  class="form-control"
                                  :name="'name'+taxRate.id"
                                  v-validate="{required: true}"
                                  v-model="taxRate.name">  -->
                        <small class="text-danger" v-if="errors.has(taxRate.hash_id)">
                          {{ getError(taxRate.hash_id) }}
                        </small>
                      </td>
                      <td>
                        <select :name="'type'+taxRate.id" v-model="taxRate.type" class="form-control" v-validate="{required: true}" >
                          <!-- <option value="FIXED_INCLUDED">{{$t('taxTypes.FIXED_INCLUDED')}}</option> -->
                          <option value="FIXED_EXCLUDED">{{$t('taxTypes.FIXED_EXCLUDED')}}</option>
                          <!-- <option value="PERCENTAGE_INCLUDED">{{$t('taxTypes.PERCENTAGE_INCLUDED')}}</option> -->
                          <option value="PERCENTAGE_EXCLUDED">{{$t('taxTypes.PERCENTAGE_EXCLUDED')}}</option>
                        </select>
                      </td>
                      <td>
                        <label class="label-currency">{{taxRate.type == 'FIXED_EXCLUDED' ? currency : '%'}}</label>

                        <input type="number" min="0" class="form-control field-currency" :name="'amount'+taxRate.id" v-model="taxRate.amount" v-validate="{required: true, min_value:0}" >
                      </td>
                      <td>
                        <input type="number" min="0" class="form-control field-currency" :name="'pos_id'+taxRate.pos_id" v-model="taxRate.pos_id" >
                      </td>
                      <td>
                        <input style="max-width: 150px" type="number" min="0" class="form-control field-currency" :name="'department_id'+taxRate.department_id" v-model="taxRate.department_id" >
                      </td>
                      <td>
                        <button class="btn btn-danger btn-icon pull-right" @click.prevent="deleteTax(location.id, taxRate.id)"><i title="Remove" class="ti-trash "></i></button>
                      </td>
                    </tr>
                    <tr v-if="location.taxes.length < taxes.length">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                <button
                  class="btn add mar-to-15"
                  v-if="location.taxes.length < taxes.length"
                  @click.prevent="addNewTax(location.id)"
                  :title="$t('general.add') + ' ' + $t('settingTaxes.single')">
                  <img src="/static/img/icons/add.png">
                  {{$t('general.add')}}
                </button>
              </div>
              <div class="text-center">
                <span class="help-block warning mb-0"><i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('settingTaxes.notice3')}} <a href="#" @click.prevent="goToCompany()">{{$t('settingTaxes.notice4')}}</a>.</span>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div v-show="currentSection === 'vat'" id="vat" class="card location-card">
        <div class="card-content">
          <form class="clearfix row">
            <div class="col-md-12">
              <div class="form-group">
                <h5>{{$t('catalogCateg.vat')}} ({{$t('catalogCateg.included')}})</h5>
                <hr class="sm">
                <table class="table mar-bt-0 location-vat-table">
                  <thead>
                    <tr>
                      <th class="location-vat-th" width="25%"><span class="location-vat-th-inner">{{$t('catalogCateg.vat')}}</span></th>
                      <th class="location-vat-th" width="25%"><span class="location-vat-th-inner">{{$t('settingTaxes.type')}}</span></th>
                      <th class="location-vat-th" width="20%"><span class="location-vat-th-inner">{{$t('settingTaxes.amount')}}</span></th>
                      <th class="location-vat-th" width="20%"><span class="location-vat-th-inner">{{ $t('settingCompany.vatPrinterIdColumn') }}</span></th>
                      <th class="location-vat-th location-vat-th-icon"><span class="location-vat-th-inner"></span></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(taxRate, vatIndex) in location.vat">
                      <td>
                        <select v-model="taxRate.tax_id"
                                class="form-control"
                                v-validate="{required: true}">
                          <option v-for="tax in vat"
                                  :value="tax.id"
                                  :disabled="disableVatOption(tax.id) && tax.id != taxRate.tax_id"
                                  >{{tax.name}}</option>
                        </select>
                        <small class="text-danger" v-if="errors.has(taxRate.hash_id)">
                          {{ getError(taxRate.hash_id) }}
                        </small>
                      </td>
                      <td>
                        <select disabled :name="'type'+taxRate.id" class="form-control" v-validate="{required: true}" >
                          <option selected="true" value="PERCENTAGE_EXCLUDED">{{$t('taxTypes.PERCENTAGE_EXCLUDED')}}</option>
                        </select>
                      </td>
                      <td>
                        <label class="label-currency">{{taxRate.type == 'FIXED_EXCLUDED' ? currency : '%'}}</label>
                        <input type="number" min="0" class="form-control field-currency" :name="'amount'+taxRate.id" v-model="taxRate.amount" v-validate="{required: true, min_value:0}" >
                      </td>
                      <td
                        class="vat-printer-td"
                        :class="{'has-error': errors.has(vatPrinterFieldName(taxRate, vatIndex))}">
                        <div class="vat-printer-input-wrap">
                          <input type="number"
                                 min="0"
                                 max="10"
                                 :placeholder="$t('settingCompany.integrators_tax_vat_printer_id')"
                                 class="form-control field-currency"
                                 :name="vatPrinterFieldName(taxRate, vatIndex)"
                                 v-model="taxRate.printer_id"
                                 v-validate="{ required: true, numeric: true, min_value: 0, max_value: 10 }" >
                          <div
                            v-show="errors.has(vatPrinterFieldName(taxRate, vatIndex))"
                            class="vat-printer-error-abs">
                            <small class="text-danger vat-printer-error">
                              {{ localizedValidatorMessage(vatPrinterFieldName(taxRate, vatIndex)) }}
                            </small>
                          </div>
                        </div>
                      </td>
                      <td>
                        <button class="btn btn-danger btn-icon pull-right" @click.prevent="deleteVat(taxRate.id, vatIndex)"><i title="Remove" class="ti-trash "></i></button>
                      </td>
                    </tr>
                    <tr v-if="!location.vat || location.vat.length < vat.length">
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                    </tr>
                  </tbody>
                </table>
                <button
                  class="btn add mar-to-15"
                  v-if="!location.vat || location.vat.length < vat.length"
                  @click.prevent="addNewVat()"
                  :title="$t('general.add') + ' ' + $t('settingTaxes.single')">
                  <img src="/static/img/icons/add.png">
                  {{$t('general.add')}}
                </button>
              </div>
              <div class="text-center">
                <span class="help-block warning mb-0"><i class="fa fa-info-circle" aria-hidden="true"></i>{{$t('settingTaxes.notice5')}} <a href="#" @click.prevent="goToCompany()">{{$t('settingTaxes.notice4')}}</a>.</span>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div v-show="currentSection === 'printer'" class="card location-card">
        <div class="card-content">
          <h5>{{$t('settingCompany.accessAndVisibility')}}</h5>
          <hr class="sm">
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>{{$t('catalogProd.hideFromPlatforms')}}</label>
                <v-select
                  v-model="selectedHiddenPlatforms"
                  multiple
                  :options="locationPlatforms"
                  label="name"
                  :placeholder="$t('catalogProd.timeOptionsValues.none')"
                  class="line-heigth-44"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-show="currentSection === 'printer'" id="printer" class="card-containerf1">
        <div class="card location-card width-50">
          <div class="card-content">
            <form class="clearfix row">
              <div class="col-md-12">
                <div class="form-group">
                  <h5>{{$t('settingCompany.cardPaymentDetails')}}</h5>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="control-label">{{$t('settingCompany.paymentGroup')}}</label>
                      <select v-model="location.payment_group"
                              name="paymentGroups"
                              class="select-primary form-control"
                              v-validate="modelValidate.paymentGroups">
                        <option v-for="(pId, pVal) in paymentGroups"
                              class="select-primary"
                              :value="pVal">{{pId}}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <div class="row">
                    <div class="col-md-6">
                      <label class="control-label">{{$t('settingCompany.posDiscount')}}</label>
                      <input type="text" v-model="location.id_discount_pos" name="posDiscount" class="form-control">
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div class="card location-card width-50">
          <div class="card-content">
            <form class="clearfix row">
              <div class="col-md-12">
                <div class="form-group">
                  <h5>{{$t('settingCompany.transport_setings')}}</h5>
                  <hr class="sm">
                  <div class="row">
                    <div class="col-md-12">
                      <p-checkbox
                      v-model="location.email_transport"
                      >{{$t('settingCompany.email_transport')}}</p-checkbox>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <br>
                        <label class="control-label">{{$t('settingCompany.google_maps_api_key')}}</label>
                        <input type="text"
                                v-model="location.google_maps_api_key"
                                name="google_maps_api_key"
                                :placeholder="$t('settingCompany.google_maps_api_key')"
                                class="form-control" >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div v-show="currentSection === 'printer'" id="printer">
        <div class="card-containerf1">
          <div class="card location-card width-50">
            <div class="card-content">
              <form class="clearfix row">
                <h5>{{$t('settingCompany.lateOrders')}}</h5>
                <hr class="sm">
                <div class="row">
                  <div class="col-md-12">
                    <p-checkbox
                      v-model="location.use_twilio"
                    >{{$t('settingCompany.twilio_call')}}</p-checkbox>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <p-checkbox
                      v-model="location.use_twilio_early_mark"
                      :disabled="!location.use_twilio"
                    >
                    {{$t('settingCompany.twilio_call_early_mark')}}
                    </p-checkbox>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <label for="phone">
                      {{$t('reports.phone')}} Twilio
                    </label>

                    <input
                      type="text"
                      id="phone"
                      class="form-control"
                      placeholder="+40770123123"
                      v-model="location.twilio_phone"
                    >
                    </input>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="card location-card width-50">
            <div class="card-content">
              <form class="clearfix row">
                <h5>{{$t('settingCompany.tipSuggestion')}}</h5>
                <hr class="sm">
                <div class="row">
                  <div class="col-md-12">
                    <label for="">{{$t('settingCompany.tipSuggestionType')}}</label>
                    <select v-model="location.tip_suggestion.type"
                          class="form-control"
                          @input="handleTipType($event)">
                      <option value="fix">Fix</option>
                      <option value="proc">Procent</option>
                    </select>
                  </div>
                </div>
                <br>
                <div class="row">
                  <div class="col-md-3">
                    <label for="sugestion1">{{$t('settingCompany.tipSuggestionSuggestion')}} 1</label>
                    <input
                      type="text"
                      id="sugestion1"
                      class="form-control"
                      v-model="location.tip_suggestion.values[0]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                  <div class="col-md-3">
                    <label for="sugestion1">{{$t('settingCompany.tipSuggestionSuggestion')}} 2</label>
                    <input
                      type="text"
                      id="sugestion1"
                      class="form-control"
                      v-model="location.tip_suggestion.values[1]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                  <div class="col-md-3">
                    <label for="sugestion1">{{$t('settingCompany.tipSuggestionSuggestion')}} 3</label>
                    <input
                      type="text"
                      id="sugestion1"
                      class="form-control"
                      v-model="location.tip_suggestion.values[2]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                  <div class="col-md-3">
                    <label for="sugestion1">{{$t('settingCompany.tipSuggestionSuggestion')}} 4</label>
                    <input
                      type="text"
                      id="sugestion1"
                      class="form-control"
                      v-model="location.tip_suggestion.values[3]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="card location-card width-50">
            <div class="card-content">
              <form class="clearfix row">
                <h5>{{$t('settingCompany.discountSuggestion')}}</h5>
                <hr class="sm">
                <div class="row">
                  <div class="col-md-12">
                    <label>{{$t('settingCompany.discountSuggestionFix')}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <label for="discountSugestionFix1">{{$t('settingCompany.discountSuggestionSuggestion')}} 1</label>
                    <input
                      type="text"
                      id="discountSugestionFix1"
                      class="form-control"
                      v-model="location.discount_suggestion.fix[0]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                  <div class="col-md-3">
                    <label for="discountSugestionFix2">{{$t('settingCompany.discountSuggestionSuggestion')}} 2</label>
                    <input
                      type="text"
                      id="discountSugestionFix2"
                      class="form-control"
                      v-model="location.discount_suggestion.fix[1]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                  <div class="col-md-3">
                    <label for="discountSugestionFix3">{{$t('settingCompany.discountSuggestionSuggestion')}} 3</label>
                    <input
                      type="text"
                      id="discountSugestionFix3"
                      class="form-control"
                      v-model="location.discount_suggestion.fix[2]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                  <div class="col-md-3">
                    <label for="discountSugestionFix4">{{$t('settingCompany.discountSuggestionSuggestion')}} 4</label>
                    <input
                      type="text"
                      id="discountSugestionFix4"
                      class="form-control"
                      v-model="location.discount_suggestion.fix[3]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                </div>
                <br>
                <div class="row">
                  <div class="col-md-12">
                    <label>{{$t('settingCompany.discountSuggestionProc')}}</label>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-3">
                    <label for="discountSugestionProc1">{{$t('settingCompany.discountSuggestionSuggestion')}} 1</label>
                    <input
                      type="text"
                      id="discountSugestionProc1"
                      class="form-control"
                      v-model="location.discount_suggestion.proc[0]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                  <div class="col-md-3">
                    <label for="discountSugestionProc2">{{$t('settingCompany.discountSuggestionSuggestion')}} 2</label>
                    <input
                      type="text"
                      id="discountSugestionProc2"
                      class="form-control"
                      v-model="location.discount_suggestion.proc[1]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                  <div class="col-md-3">
                    <label for="discountSugestionProc3">{{$t('settingCompany.discountSuggestionSuggestion')}} 3</label>
                    <input
                      type="text"
                      id="discountSugestionProc3"
                      class="form-control"
                      v-model="location.discount_suggestion.proc[2]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                  <div class="col-md-3">
                    <label for="discountSugestionProc4">{{$t('settingCompany.discountSuggestionSuggestion')}} 4</label>
                    <input
                      type="text"
                      id="discountSugestionProc4"
                      class="form-control"
                      v-model="location.discount_suggestion.proc[3]"
                      v-validate="'required'"
                    >
                    </input>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="card-containerf1">
          <div class="card location-card width-50">
            <div class="card-content">
              <form class="clearfix row">
                <div class="col-md-12">
                  <div class="form-group">
                    <h5>{{$t('settingCompany.printSettings')}}</h5>
                    <hr class="sm">
                    <div class="row">
                      <div class="col-md-12">
                        <p-checkbox
                          v-model="location.auto_print"
                        >{{$t('settingCompany.automatPrintOrder')}}</p-checkbox>
                      </div>
                    </div>
                    <div class="row mar-bt-10" style="">
                      <div class="col-md-12">
                        <p-checkbox
                          v-model="location.auto_print_local_server"
                        >{{$t('settingCompany.autoPrintLocalServer')}}</p-checkbox>
                      </div>
                    </div>
                    <div class="row mar-bt-10" style="">
                      <div class="col-md-12">
                        <p-checkbox
                          v-model="location.use_printer"
                        >{{$t('settingCompany.autoSendOrderToPrinter')}}</p-checkbox>
                      </div>
                    </div>
                    <div class="row" v-if="location.use_printer" style="">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="control-label">{{$t('settingCompany.printerIp')}}</label>
                          <input type="text"
                                  v-model="location.printer_ip"
                                  name="printer_ip"
                                  :placeholder="$t('settingCompany.printerIp')"
                                  class="form-control" >
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="control-label">{{$t('settingCompany.printerPort')}}</label>
                          <input type="text"
                                  v-model="location.printer_port"
                                  name="printer_port"
                                  :placeholder="$t('settingCompany.printerPort')"
                                  class="form-control" >
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="card-containerf1">
          <div class="card location-card width-50">
            <div class="card-content">
              <form class="clearfix row">
                <div class="col-md-12">
                  <div class="form-group">
                    <h5>{{$t('settingCompany.reportProductOptionTitle')}}</h5>
                    <hr class="sm">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="control-label">{{$t('settingCompany.email__prod_opt_report')}}</label>
                          <input type="text"
                                  v-model="location.email__prod_opt_report"
                                  name="email__prod_opt_report"
                                  :placeholder="$t('settingCompany.email__prod_opt_report')"
                                  class="form-control" >
                        </div>
                        <div class="form-group">
                          {{ $t('settingCompany.time__prod_opt_report') }}
                            <el-time-select
                              placeholder="Start time"
                              v-model="location.time__prod_opt_report"
                              :picker-options="pickerOptionsReport"
                            />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="card location-card width-50">
            <div class="card-content">
              <form class="clearfix row">
                <div class="col-md-12">
                  <div class="form-group">
                    <h5>{{$t('settingCompany.integrators_department')}}</h5>
                    <hr class="sm">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="control-label">{{$t('settingCompany.integrators_department_id')}}</label>
                          <input type="number"
                                  v-model="location.integrators_department_id"
                                  name="integrators_department_id"
                                  :placeholder="$t('settingCompany.integrators_department_id')"
                                  class="form-control" >
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                      <div class="col-md-6">
                        <div class="form-group">
                          <label class="control-label">{{$t('settingCompany.integrators_tax_vat_amount')}}</label>
                          <input type="number"
                                  v-model="location.integrators_tax_vat_amount"
                                  name="integrators_tax_vat_amount"
                                  :placeholder="$t('settingCompany.integrators_tax_vat_amount')"
                                  class="form-control" >
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group" :class="{'has-error': errors.has('integrators_tax_vat_printer_id')}">
                          <label class="control-label">{{$t('settingCompany.integrators_tax_vat_printer_id')}}</label>
                          <input type="number"
                                  min="0"
                                  max="10"
                                  v-model="location.integrators_tax_vat_printer_id"
                                  name="integrators_tax_vat_printer_id"
                                  :placeholder="$t('settingCompany.integrators_tax_vat_printer_id')"
                                  class="form-control"
                                  v-validate="integratorsTaxVatPrinterRules" >
                          <small class="text-danger" v-if="errors.has('integrators_tax_vat_printer_id')">
                            {{ localizedValidatorMessage('integrators_tax_vat_printer_id') }}
                          </small>
                        </div>
                      </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div v-show="currentSection === 'invoices'" id="invoices" class="card location-card">
        <div class="card-content">
          <form class="clearfix row">
            <div class="col-md-12">
              <div class="form-group">
                <div class="col-md-12">
                  <div class="flex-container">
                    <h5>{{$t('settingCompany.invoicePerOrder')}}</h5>
                    <p-switch v-model="location.smartbill_status" type="success" class="mar-bt-0"></p-switch>
                  </div>
                  <hr class="mar-to-5">
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">{{$t('settingCompany.apiKey')}}</label>
                    <input
                      v-validate="{required: location.smartbill_status}"
                      :disabled="!location.smartbill_status"
                      type="text"
                      v-model="location.smartbill_api_key"
                      name="street"
                      :placeholder="$t('settingCompany.apiKey')"
                      class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">{{$t('settingCompany.cif')}}</label>
                    <input
                      :disabled="!location.smartbill_status"
                      type="text"
                      v-model="location.smartbill_cif"
                      name="street"
                      :placeholder="$t('settingCompany.cif')"
                      class="form-control"
                      v-validate="{required: location.smartbill_status}">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">{{$t('settingCompany.email')}}</label>
                    <input
                      v-validate="{required: location.smartbill_status}"
                      :disabled="!location.smartbill_status"
                      type="text"
                      v-model="location.smartbill_email"
                      name="street"
                      :placeholder="$t('marketingPromos.email')"
                      class="form-control">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="control-label">{{$t('settingCompany.series')}}</label>
                    <input
                      :disabled="!location.smartbill_status"
                      type="text"
                      v-model="location.smartbill_series"
                      name="street"
                      :placeholder="$t('settingCompany.series')"
                      class="form-control"
                      v-validate="{required: location.smartbill_status}">
                  </div>
                </div>
                <div class="col-md-6">
                  <p-checkbox
                    v-model="location.smartbill_send_auto"
                    :disabled="!location.smartbill_status"
                  >{{$t('settingCompany.automatedInvoice')}}</p-checkbox>
                  <p-checkbox
                    v-model="location.smartbill_add_to_cc"
                    :disabled="!location.smartbill_status"
                  >{{$t('settingCompany.addToCC')}}</p-checkbox>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>

      <div v-show="currentSection === 'digital-waiter'" id="digital-waiter" class="card location-card">
        <div class="card-content">
          <form class="clearfix row">
            <template>
              <div class="col-md-12">
                <h5>{{$t('catalogProdOpt.menuQr')}}</h5>
                <hr class="sm">
                <div class="form-group">
                  <div class="col-md-2">
                    {{$t('settingCompany.digitalWaiterMode')}}
                    <select v-model="location.use_dynamic_menu"
                          class="form-control"
                          @input="handleMenu($event)">
                      <option v-for="menu in menuType"
                              :value="menu.id"
                              >{{menu.label}}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <hr>
              </div>
              <div v-if="!location.use_dynamic_menu" class="col-md-6">
                <file-input
                  :location="location"
                />
              </div>
              <div v-if="location.use_dynamic_menu" class="col-md-6">
                <display-qr
                  v-if="location.dynamic_qr_code"
                  :location="location"
                />
              </div>
            </template>
          </form>
        </div>
      </div>

      <div v-show="currentSection === 'kiosk-qr-settings'" id="kiosk-qr-settings">
        <div class="card-containerf1">
          <div class="card location-card width-50">
            <div class="card-content">
              <form class="clearfix row">
                <div class="col-md-12">
                  <h5>{{$t('settingCompany.kioskSettingsTitle')}}</h5>
                  <hr class="sm">
                  <div class="col-md-12">
                    <p-checkbox v-model="location.kiosk_is_using_top_category">{{$t('settingCompany.kioskUsingTopCategoryLabel')}}</p-checkbox>
                    <small class="text-muted">{{$t('settingCompany.kioskUsingTopCategoryHelp')}}</small>
                  </div>
                  <div class="col-md-12 mar-to-15">
                    <p-checkbox v-model="location.kiosk_is_using_fiscal_receipt_for_cash">{{$t('settingCompany.kioskFiscalReceiptForCashLabel')}}</p-checkbox>
                  </div>
                  <div class="col-md-12">
                    <p-checkbox v-model="location.kiosk_is_using_non_fiscal_receipt_for_card">{{$t('settingCompany.kioskNonFiscalReceiptForCardLabel')}}</p-checkbox>
                  </div>
                  <div class="col-md-12 mar-to-15">
                    <label>{{$t('settingCompany.kioskAddToCartNotificationPositionLabel')}}</label>
                    <select
                      class="form-control"
                      v-model.number="location.kiosk_add_to_cart_notification_position"
                    >
                      <option :value="1">{{$t('settingCompany.kioskAddToCartNotificationPositionPopup')}}</option>
                      <option :value="2">{{$t('settingCompany.kioskAddToCartNotificationPositionSidebar')}}</option>
                    </select>
                  </div>
                  <div class="col-md-12 mar-to-15">
                    <p-checkbox
                      v-model="location.kiosk_allow_fidelities"
                      :disabled="!companyLoyaltyInUse"
                    >{{$t('settingsOrdering.allow_fidelities')}}</p-checkbox>
                    <small class="text-muted">{{$t('settingsOrdering.allow_fidelitiesHelp')}}</small>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="card location-card width-50">
            <div class="card-content">
              <form class="clearfix row">
                <h5>{{$t('settingCompany.reorderPopupTitle')}}</h5>
                <hr class="sm">
                <div class="row">
                  <div class="col-md-12">
                    <label for="reorderPopupMinutes">{{$t('settingCompany.reorderPopupMinutes')}}</label>
                    <input
                      type="number"
                      min="0"
                      id="reorderPopupMinutes"
                      class="form-control"
                      v-model.number="location.reorder_popup_minutes"
                    >
                    </input>
                    <small class="text-muted">{{$t('settingCompany.reorderPopupHelp')}}</small>
                  </div>
                  <div class="col-md-12 mar-to-15">
                    <p-checkbox v-model="location.allow_open_order">{{$t('settingCompany.allowOpenOrderLabel')}}</p-checkbox>
                    <small class="text-muted">{{$t('settingCompany.allowOpenOrderHelp')}}</small>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div v-show="currentSection === 'pos-settings'" id="pos-settings">
        <div class="card-containerf1">
          <div class="card location-card width-50">
            <div class="card-content">
              <form class="clearfix row">
                <div class="col-md-12">
                  <div class="form-group">
                    <h5>{{$t('crossSell.title')}}</h5>
                    <hr class="sm">
                    <p class="text-muted mar-bt-10">{{$t('crossSell.help')}}</p>
                    <product-cross-sell-picker
                      v-if="location && location.id"
                      :key="'cross-sell-' + location.id"
                      v-model="location.cross_sell_products"
                      :company-id="location.company_id"
                      :location-id="location.true_id || location.id"
                      :max-items="10"
                    />
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="card location-card width-50">
            <div class="card-content">
              <form class="clearfix row">
                <div class="col-md-12">
                  <form class="clearfix row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <h5>{{$t('settingTable.posSet')}}</h5>
                        <hr class="sm">
                        <div class="row">
                          <div class="col-md-12">
                            <p-checkbox
                              v-model="location.allow_pos_use_coupons"
                            >{{$t('settingTable.allowPosUseCoupons')}}</p-checkbox>
                          </div>
                           <div class="col-md-12">
                            <p-checkbox
                              v-model="location.pos_always_set_client"
                            >{{$t('settingTable.posSetClientOnOrder')}}</p-checkbox>
                          </div>
                           <div class="col-md-12">
                            <p-checkbox
                              v-model="location.pos_confirm_order_close_on_method_select"
                            >{{$t('settingTable.pos_confirm_order_close_on_method_select')}}</p-checkbox>
                          </div>
                          <div class="col-md-12">
                            <p-checkbox
                              v-model="location.pos_display_all_product_options"
                            >{{$t('settingTable.posDisplayAllProductOptions')}}</p-checkbox>
                          </div>
                          <div class="col-md-12">
                            <p-checkbox
                              v-model="location.pos_allow_group_products"
                            >{{$t('settingTable.posAllowGroupProducts')}}</p-checkbox>
                          </div>
                          <div class="col-md-12">
                            <p-checkbox
                              v-model="location.force_credit_for_integration_cash_orders"
                            >{{$t('settingTable.forceCreditForIntegrationCashOrders')}}</p-checkbox>
                          </div>
                          <div class="col-md-12">
                            <p-checkbox
                              v-model="location.pos_use_yumm_voucher"
                            >{{$t('settingTable.posUseYummVoucher')}}</p-checkbox>
                          </div>
                          <div class="col-md-12">
                            <p-checkbox
                              v-model="location.pos_use_stock"
                            >{{$t('settingTable.posUseStock')}}</p-checkbox>
                          </div>
                          <div class="col-md-12">
                            <p-checkbox
                              v-model="location.pos_ask_storno_back_in_stock"
                            >{{$t('settingTable.posAskStornoBackInStock')}}</p-checkbox>
                          </div>
                          <div class="col-md-12">
                            <p-checkbox
                              v-model="location.pos_keep_first_waiter_id_order_split"
                            >{{$t('settingTable.pos_keep_first_waiter_id_order_split')}}</p-checkbox>
                          </div>
                          <div class="col-md-12">
                            <p-checkbox
                              v-model="location.pos_display_tips_on_order"
                            >{{$t('settingTable.posDisplayTipsOnOrder')}}</p-checkbox>
                          </div>
                          <div class="col-md-12">
                            <label class="details-label mar-rt-10">{{$t('settingTable.posDefaultCourseCount')}}</label>
                            <input type="number" min="0" max="10" class="form-control"
                              v-model="location.pos_default_course_count"
                            ></input>
                          </div>
                          <div class="col-md-12">
                            <label class="details-label mar-rt-10 mar-to-5">{{$t('settingTable.staff_food_daily_budget')}}</label>
                            <input type="number" min="0" step="5" class="form-control"
                              v-model="location.staff_food_daily_budget"
                            ></input>
                          </div>
                          <div class="col-md-12" :class="{'has-error': errors.has('other_taxes_vat_printer_id')}">
                            <label class="details-label mar-rt-10 mar-to-5">{{$t('settingCompany.other_taxes_vat_printer_id')}}</label>
                            <input type="number"
                                    min="0"
                                    max="10"
                                    v-model="location.other_taxes_vat_printer_id"
                                    name="other_taxes_vat_printer_id"
                                    class="form-control"
                                    v-validate="otherTaxesVatPrinterRules" >
                            <small class="text-danger" v-if="errors.has('other_taxes_vat_printer_id')">
                              {{ localizedValidatorMessage('other_taxes_vat_printer_id') }}
                            </small>
                          </div>
                          <div class="col-md-12" :class="{'has-error': errors.has('donation_vat_printer_id')}">
                            <label class="details-label mar-rt-10 mar-to-5">{{$t('settingCompany.donation_vat_printer_id')}}</label>
                            <input type="number"
                                    min="0"
                                    max="10"
                                    v-model="location.donation_vat_printer_id"
                                    name="donation_vat_printer_id"
                                    class="form-control"
                                    v-validate="donationVatPrinterRules" >
                            <small class="text-danger" v-if="errors.has('donation_vat_printer_id')">
                              {{ localizedValidatorMessage('donation_vat_printer_id') }}
                            </small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import RSystemSetup from './RSystemSetup.vue'
  import Vue from 'vue'
  import {Input, Select} from 'element-ui'
  import swal from 'sweetalert2'
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import FileInput from 'src/components/UIComponents/Inputs/FileInput.vue'
  import ImageInput from 'src/components/UIComponents/Inputs/ImageInput.vue'
  import DisplayQr from 'src/components/UIComponents/Inputs/DisplayQr.vue'
  import ImportProductsInput from 'src/components/UIComponents/Inputs/ImportProductsInput.vue'
  import ImportProductsLegacyInput from 'src/components/UIComponents/Inputs/ImportProductsLegacyInput.vue'
  import ArchiveInput from 'src/components/UIComponents/Inputs/ArchiveInput.vue'
  import DisplayQrApp from 'src/components/UIComponents/Inputs/DisplayQrApp.vue'
  import ProductCrossSellPicker from 'src/components/UIComponents/Inputs/ProductCrossSellPicker.vue'
  import DeliveryMethods from './DeliveryMethods.vue'
  import 'sweetalert2/dist/sweetalert2.css'
  // import {mapFields} from 'vee-validate'
  Vue.use(Input)
  Vue.use(Select)

  const COUNTRIES_LIST = [
    {
      name: 'România',
      counties: [
        { code: 'AB', name: 'Alba' },
        { code: 'AR', name: 'Arad' },
        { code: 'AG', name: 'Argeș' },
        { code: 'BC', name: 'Bacău' },
        { code: 'BH', name: 'Bihor' },
        { code: 'BN', name: 'Bistrița-Năsăud' },
        { code: 'BT', name: 'Botoșani' },
        { code: 'BR', name: 'Brăila' },
        { code: 'BV', name: 'Brașov' },
        { code: 'B', name: 'București' },
        { code: 'BZ', name: 'Buzău' },
        { code: 'CS', name: 'Caraș-Severin' },
        { code: 'CL', name: 'Călărași' },
        { code: 'CJ', name: 'Cluj' },
        { code: 'CT', name: 'Constanța' },
        { code: 'CV', name: 'Covasna' },
        { code: 'DB', name: 'Dâmbovița' },
        { code: 'DJ', name: 'Dolj' },
        { code: 'GL', name: 'Galați' },
        { code: 'GR', name: 'Giurgiu' },
        { code: 'GJ', name: 'Gorj' },
        { code: 'HR', name: 'Harghita' },
        { code: 'HD', name: 'Hunedoara' },
        { code: 'IL', name: 'Ialomița' },
        { code: 'IS', name: 'Iași' },
        { code: 'IF', name: 'Ilfov' },
        { code: 'MM', name: 'Maramureș' },
        { code: 'MH', name: 'Mehedinți' },
        { code: 'MS', name: 'Mureș' },
        { code: 'NT', name: 'Neamț' },
        { code: 'OT', name: 'Olt' },
        { code: 'PH', name: 'Prahova' },
        { code: 'SM', name: 'Satu Mare' },
        { code: 'SJ', name: 'Sălaj' },
        { code: 'SB', name: 'Sibiu' },
        { code: 'SV', name: 'Suceava' },
        { code: 'TR', name: 'Teleorman' },
        { code: 'TM', name: 'Timiș' },
        { code: 'TL', name: 'Tulcea' },
        { code: 'VS', name: 'Vaslui' },
        { code: 'VL', name: 'Vâlcea' },
        { code: 'VN', name: 'Vrancea' }
      ]
    },
    { name: 'Albania', counties: [] },
    { name: 'Andorra', counties: [] },
    { name: 'Austria', counties: [] },
    { name: 'Belarus', counties: [] },
    { name: 'Belgia', counties: [] },
    { name: 'Bosnia și Herțegovina', counties: [] },
    { name: 'Bulgaria', counties: [] },
    { name: 'Croația', counties: [] },
    { name: 'Cehia', counties: [] },
    { name: 'Cipru', counties: [] },
    { name: 'Danemarca', counties: [] },
    { name: 'Elveția', counties: [] },
    { name: 'Estonia', counties: [] },
    { name: 'Finlanda', counties: [] },
    { name: 'Franța', counties: [] },
    { name: 'Germania', counties: [] },
    { name: 'Grecia', counties: [] },
    { name: 'Irlanda', counties: [] },
    { name: 'Islanda', counties: [] },
    { name: 'Italia', counties: [] },
    { name: 'Kosovo', counties: [] },
    { name: 'Letonia', counties: [] },
    { name: 'Liechtenstein', counties: [] },
    { name: 'Lituania', counties: [] },
    { name: 'Luxemburg', counties: [] },
    { name: 'Macedonia de Nord', counties: [] },
    { name: 'Malta', counties: [] },
    { name: 'Moldova', counties: [] },
    { name: 'Monaco', counties: [] },
    { name: 'Muntenegru', counties: [] },
    { name: 'Norvegia', counties: [] },
    { name: 'Olanda', counties: [] },
    { name: 'Polonia', counties: [] },
    { name: 'Portugalia', counties: [] },
    { name: 'Regatul Unit', counties: [] },
    { name: 'Rusia', counties: [] },
    { name: 'San Marino', counties: [] },
    { name: 'Serbia', counties: [] },
    { name: 'Slovacia', counties: [] },
    { name: 'Slovenia', counties: [] },
    { name: 'Spania', counties: [] },
    { name: 'Suedia', counties: [] },
    { name: 'Turcia', counties: [] },
    { name: 'Ucraina', counties: [] },
    { name: 'Ungaria', counties: [] },
    { name: 'Vatican', counties: [] }
  ]


  export default {
    components: {
      RSystemSetup,
      [Input.name]: Input,
      PSwitch,
      FileInput,
      ImageInput,
      DisplayQr,
      DisplayQrApp,
      ImportProductsInput,
      ImportProductsLegacyInput,
      ArchiveInput,
      ProductCrossSellPicker,
      DeliveryMethods
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    watch: {
      'location.integrators_department_id': 'clearIntegratorsPrinterErrorWhenOptional',
      'location.integrators_tax_vat_amount': 'clearIntegratorsPrinterErrorWhenOptional',
      'location.other_taxes_vat_printer_id': 'clearOtherTaxesVatPrinterErrorWhenOptional',
      'location.donation_vat_printer_id': 'clearDonationVatPrinterErrorWhenOptional',
      companyLoyaltyInUse (enabled) {
        if (!enabled && this.location) {
          this.location.kiosk_allow_fidelities = false
        }
      }
    },
    data () {
      return {
        rSystemBusy: false,
        id: null,
        location: null,
        selectedHiddenPlatforms: [],
        locationPlatforms: [
          {id: 1, name: this.$t('addOrder.application')},
          {id: 2, name: 'Website'}
        ],
        currentSection: 'start',
        apiUrl: '',
        model: this.value || this.modeldata,
        countries: [], // this.countries
        sortMethodsList: [],
        states: [],
        taxes: [],
        vat: [],
        countriesList: COUNTRIES_LIST,
        topCategories: null,
        displayIntegrationCard: false,
        currency: this.getCurrencySymbol((this.$session.get('selectedCompanyData') || {}).currency_iso),
        showDelete: false,
        boltStatus: false,
        boltSchedule: [],
        allLocations: [],
        inv_fiscal_code_disabled_field: false,
        modelValidate: {
          name: {required: true},
          email: {required: true},
          phone: {required: true},
          number: {required: true},
          street: {required: true},
          city: {required: true},
          state: {required: true},
          country: {required: true},
          working_hours: {required: true},
          paymentGroups: {required: true}
        },
        timeFormat: 'HH:mm', // this.getCompanyDetail('time_format'),
        dateFormat: 'DD/MM/YYYY', // this.getCompanyDetail('date_format'),
        pickerNames: ['date_from', 'date_to'],
        days: [
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday',
          'sunday'
        ],
        pickerOptions: {
          start: '00:00',
          step: '00:15',
          end: '23:59',
          format: this.timeFormat
        },
        pickerOptionsReport: {
          start: '01:00',
          step: '00:30',
          end: '23:59',
          format: this.timeFormat
        },
        showUpdateWarning: false,
        languages: (this.$session.get('defaultData') || {}).available_languages || [],
        windowHeight: 0,
        navbarHeaderHeight: 0,
        navButtonsHeight: 0,
        pageTopHeight: 76,
        loading: true,
        initialLoadError: false,
        initialLoadRequests: {
          taxes: false,
          location: false,
          paymentGroups: false,
          locations: false
        },
        glovoStatus: false,
        paymentGroups: null,
        deliveryMethods: [],
        menuType: [{'id': 0, 'label': 'PDF'}, {'id': 1, 'label': 'Dynamic'}],
        defaultData: [],
        hasLocationErrors: false,
        hasPaymentGroupErrors: false,
        hasVatErrors: false,
        hasDeliveryMethodsErrors: false,
        nexusFrom: null,
        nexusTo: null,
        previousPosnetDate: null,
        previousPosnetSwitchState: null,
        woltSchedule: [],
        woltStatus: false,
        locationPriceProfiles: [],
        selectedPriceProfileId: null,
        locationHasProducts: false,
        creatingDefaultPriceProfile: false
      }
    },
    updated: function () {
    },
    computed: {
      companyLoyaltyInUse () {
        const companyData = this.$session.get('selectedCompanyData') || {}
        return !!(companyData.loyalty_in_use === true || companyData.loyalty_in_use === 1 || companyData.loyalty_in_use === '1')
      },
      downloadImportHref () {
        return this.apiUrl + 'download-import-form?token=' + this.$session.get('token')
      },
      downloadLegacyImportHref () {
        return this.apiUrl + 'download-import-form-legacy?token=' + this.$session.get('token')
      },
      exportProductsHref () {
        if (!this.canExportProducts) {
          return null
        }
        return this.apiUrl + 'import-location/products/export?token=' + this.$session.get('token') +
          '&location_id=' + encodeURIComponent(this.location.true_id) +
          '&company_id=' + encodeURIComponent(this.$session.get('selectedCompany')) +
          '&price_profiles_id=' + encodeURIComponent(this.selectedPriceProfileId)
      },
      exportImagesHref () {
        if (!this.canExportImages) {
          return null
        }
        return this.apiUrl + 'import-location/products/export-images?token=' + this.$session.get('token') +
          '&location_id=' + encodeURIComponent(this.location.true_id) +
          '&company_id=' + encodeURIComponent(this.$session.get('selectedCompany'))
      },
      canExportProducts () {
        return !!(
          this.location &&
          this.location.true_id &&
          this.selectedPriceProfileId &&
          this.locationHasProducts
        )
      },
      canExportImages () {
        return !!(
          this.location &&
          this.location.true_id &&
          this.locationHasProducts
        )
      },
      exportDisabledReason () {
        if (!this.locationHasProducts) {
          return this.$t('productImport.noProductsForExport')
        }
        if (!this.selectedPriceProfileId) {
          return this.$t('productImport.priceProfileRequired')
        }
        return ''
      },
      exportImagesDisabledReason () {
        if (!this.locationHasProducts) {
          return this.$t('productImport.noProductsForExport')
        }
        return ''
      },
      selectedCountry () {
        return this.countriesList.find(c => c.name === this.location.inv_country) || null
      },
      isNexusDatesValid () {
        return this.nexusFrom && this.nexusTo && this.nexusFrom !== null && this.nexusTo !== null
      },
      boltEndTimeOptions () {
        const out = []
        for (let hour = 0; hour < 24; hour++) {
          for (let minute = 0; minute < 60; minute += 15) {
            if (hour === 23 && minute > 55) break
            const h = String(hour).padStart(2, '0')
            const m = String(minute).padStart(2, '0')
            out.push(`${h}:${m}`)
          }
        }
        if (!out.includes('23:59')) {
          out.push('23:59')
        }
        return out
      },
      integratorsTaxVatPrinterRules () {
        if (!this.location) {
          return {}
        }
        const dept = this.location.integrators_department_id
        const amt = this.location.integrators_tax_vat_amount
        const deptFilled = dept !== null && dept !== undefined && dept !== ''
        const amtFilled = amt !== null && amt !== undefined && amt !== ''
        if (!deptFilled || !amtFilled) {
          return {}
        }
        return { required: true, numeric: true, min_value: 0, max_value: 10 }
      },
      otherTaxesVatPrinterRules () {
        const val = this.location && this.location.other_taxes_vat_printer_id
        const filled = val !== null && val !== undefined && val !== ''
        if (!filled) {
          return {}
        }
        return { numeric: true, min_value: 0, max_value: 10 }
      },
      donationVatPrinterRules () {
        const val = this.location && this.location.donation_vat_printer_id
        const filled = val !== null && val !== undefined && val !== ''
        if (!filled) {
          return {}
        }
        return { numeric: true, min_value: 0, max_value: 10 }
      }
    },
    created () {
      this.apiUrl = process.env.API_BASE_URL
      const pageRoute = this.route && this.route.params ? this.route : this.$route
      this.id = (pageRoute && pageRoute.params && pageRoute.params.id) || null
      this.loadLocationForm()

      // Load top categories for POS settings select
      var data2 = {
        token: this.$session.get('token'),
        company_id: this.$session.get('selectedCompany')
      }
      this.apiRequest('/topcategory', 'GET', data2, (topCatResp) => {
        if (topCatResp.status === true) {
          this.topCategories = topCatResp.data
        }
      })

      this.$bus.$on('upload-location-image', payload => {
        this.location[payload.field] = payload.file
        // this.model.locations_details.forEach((value, index) => {
        //   if (value.id === payload.id) {
        //     this.model.locations_details[index][payload.field] = payload.file
        //   }
        // })
      })

      this.$bus.$on('remove-upload-location-image', payload => {
        this.location[payload.field] = null
        // this.model.locations_details.forEach((value, index) => {
        //   if (value.id === payload.id) {
        //     this.model.locations_details[index][payload.field] = null
        //   }
        // })
      })

      // Listen for child component requests completion
      this.$bus.$on('delivery-methods-loaded', () => {
        // Child component will emit when all its requests are done
        this.checkInitialLoadComplete()
      })
    },
    mounted () {
      this.$nextTick(() => {
        this.doHeightCalculation()

        window.addEventListener('resize', () => {
          this.doHeightCalculation()
        })
      })
    },
    methods: {
      loadLocationForm () {
        this.loading = true
        this.initialLoadError = false
        this.initialLoadRequests = {taxes: false, location: false, paymentGroups: false, locations: false}
        this.defaultData = this.$session.get('defaultData') || {}
        this.countries = this.defaultData.countries || []
        this.getLocations()
        this.getLocationData()
        this.getData()
        this.requestInitialData('taxes', '/settings/taxes', {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany')
        }, response => {
          this.taxes = response.data.taxes
          this.vat = response.data.vat
        })
      },
      requestInitialData (name, url, data, hydrate) {
        const fail = () => {
          this.initialLoadError = true
          this.markRequestComplete(name)
        }
        try {
          this.apiRequest(url, 'GET', data, response => {
            try {
              if (!response || response.status !== true || response.data == null) {
                this.initialLoadError = true
                return
              }
              hydrate(response)
            } catch (error) {
              this.initialLoadError = true
            } finally {
              this.markRequestComplete(name)
            }
          })
        } catch (error) {
          fail()
        }
      },
      onCountryChange () {
        // Resetează județul când se schimbă țara
        this.location.inv_county = ''
      },
      checkInitialLoadComplete () {
        // Check if all initial load requests are complete
        const allComplete = Object.values(this.initialLoadRequests).every(status => status === true)
        if (allComplete) {
          this.loading = false
        }
      },
      markRequestComplete (requestName) {
        this.initialLoadRequests[requestName] = true
        this.checkInitialLoadComplete()
      },
      redirectToWolt () {
        this.loading = true
        var data = {
          token: this.$session.get('token')
        }

        this.apiRequest('/wolt/integrate-location/' + this.location.wolt_company_id, 'POST', data, (response) => {
          if (response.status) {
            window.location.href = response.data
            // swal({
            //   text: this.$t('bolt.sync'),
            //   type: 'success',
            //   showCancelButton: false
            // })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      updateWoltMenu () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          wolt_company_id: this.location.wolt_company_id
        }
        this.apiRequest('/wolt/export-menu', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('bolt.sync'),
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      handleWoltStatus () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          wolt_company_id: this.location.wolt_company_id,
          active: this.woltStatus
        }
        this.apiRequest('/wolt/toggle-location-status', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('bolt.sync'),
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
            this.woltStatus = !this.woltStatus
          }
          this.loading = false
        })
      },
      updateWoltSchedule () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          wolt_company_id: this.location.wolt_company_id,
          schedule: this.woltSchedule
        }
        this.apiRequest('/wolt/update-schedule', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('bolt.sync'),
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      addMoreWoltIntervals (dayIdx) {
        this.woltSchedule[dayIdx].intervals.push({
          opening_time: null,
          closing_time: null
        })
      },
      deleteWoltIntervals (intervalKey, dayIdx) {
        this.woltSchedule[dayIdx].intervals.splice(intervalKey, 1)
      },
      handleBoltStatus () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          bolt_company_id: this.location.bolt_company_id,
          active: this.boltStatus
        }

        this.apiRequest('/bolt/handle-open', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('bolt.sync'),
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
            this.boltStatus = !this.boltStatus
          }
          this.loading = false
        })
      },
      updateBoltSchedule () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          bolt_company_id: this.location.bolt_company_id,
          schedule: this.boltSchedule
        }

        this.apiRequest('/bolt/update-schedule', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('bolt.sync'),
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      updateBoltMenu () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          bolt_company_id: this.location.bolt_company_id
        }

        this.apiRequest('/bolt/push-menu', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('bolt.sync'),
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      handlePosnetReportToggle () {
        const currentState = this.location.posnet_company_show_report
        // const previousState = this.previousPosnetSwitchState

        // Store the current state as previous for next time
        this.previousPosnetSwitchState = currentState

        // If currentState is false, it means switch was just turned OFF
        // If currentState is true, it means switch was just turned ON
        // Only show confirmation when activating the switch (not deactivating)
        if (currentState === false) {
          // Switch is being deactivated, just make the API call without confirmation
          this.loading = true
          const id = this.location.posnet_company_id
          const reportDate = this.location.posnet_company_report_date || this.getTodayDate()
          var data = {
            token: this.$session.get('token'),
            location_id: this.location.true_id,
            company_id: this.location.company_id,
            active: false,
            report_date: reportDate
          }

          this.apiRequest('/posnet/v2/enable-report/' + id, 'POST', data, (response) => {
            if (response.status) {
              swal({
                text: this.$t('general.success'),
                type: 'success',
                showConfirmButton: false
              })
            } else {
              swal({
                text: this.$t('general.error'),
                type: 'error',
                showConfirmButton: false
              })
              // Revert the switch
              this.$set(this.location, 'posnet_company_show_report', true)
            }
            this.loading = false
          })
          return
        }

        // Switch is being activated, show confirmation
        const reportDate = this.location.posnet_company_report_date

        // If date is null or empty, ask about automated mode for yesterday's date
        if (!reportDate || reportDate === '') {
          const yesterdayDate = this.getYesterdayDate()
          swal({
            text: this.$t('posnet.confirmActivateReportAutomated', { date: yesterdayDate }) || `Are you sure you want to activate the report in automated mode for yesterday's date (${yesterdayDate})?`,
            type: 'question',
            showCancelButton: true,
            confirmButtonText: this.$t('general.yes'),
            cancelButtonText: this.$t('general.no')
          }).then((result) => {
            if (result) {
              this.loading = true
              const id = this.location.posnet_company_id
              var data = {
                token: this.$session.get('token'),
                location_id: this.location.true_id,
                company_id: this.location.company_id,
                active: this.location.posnet_company_show_report,
                report_date: null
              }

              this.apiRequest('/posnet/v2/enable-report/' + id, 'POST', data, (response) => {
                if (response.status) {
                  swal({
                    text: this.$t('general.success'),
                    type: 'success',
                    showConfirmButton: false
                  })
                  this.previousPosnetDate = null
                } else {
                  swal({
                    text: this.$t('general.error'),
                    type: 'error',
                    showConfirmButton: false
                  })
                  // Revert the switch
                  Vue.set(this.location, 'posnet_company_show_report', false)
                }
                this.loading = false
              })
            } else {
              // User cancelled, revert the switch
              Vue.set(this.location, 'posnet_company_show_report', false)
            }
          })
          .catch(() => {
            this.$set(this.location, 'posnet_company_show_report', false)
          })
        } else {
          // Date is set, ask about the specific date
          swal({
            text: this.$t('posnet.confirmActivateReport', { date: reportDate }),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: this.$t('general.yes'),
            cancelButtonText: this.$t('general.no')
          }).then((result) => {
            if (result) {
              this.loading = true
              const id = this.location.posnet_company_id
              var data = {
                token: this.$session.get('token'),
                location_id: this.location.true_id,
                company_id: this.location.company_id,
                active: this.location.posnet_company_show_report,
                report_date: reportDate
              }

              this.apiRequest('/posnet/v2/enable-report/' + id, 'POST', data, (response) => {
                if (response.status) {
                  swal({
                    text: this.$t('general.success'),
                    type: 'success',
                    showConfirmButton: false
                  })
                  this.previousPosnetDate = reportDate
                } else {
                  swal({
                    text: this.$t('general.error'),
                    type: 'error',
                    showConfirmButton: false
                  })
                  // Revert the switch
                  Vue.set(this.location, 'posnet_company_show_report', false)
                }
                this.loading = false
              })
            } else {
              // User cancelled, revert the switch
              Vue.set(this.location, 'posnet_company_show_report', false)
              console.log('this.location', this.location.posnet_company_show_report)
              // this.$set(this.location, 'posnet_company_show_report', false)
            }
          })
          .catch(() => {
            this.$set(this.location, 'posnet_company_show_report', false)
          })
        }
      },
      handlePosnetDateFocus () {
        // Store the current date before user changes it
        if (this.location.posnet_company_report_date) {
          this.previousPosnetDate = this.location.posnet_company_report_date
        }
      },
      handlePosnetDateVisible (visible) {
        // When date picker becomes visible, store the current date
        if (visible && this.location.posnet_company_report_date) {
          this.previousPosnetDate = this.location.posnet_company_report_date
        }
      },
      handlePosnetDateChange (newDate) {
        const self = this
        // Get the previous date - must be stored before the change event fires
        const previousDate = this.previousPosnetDate

        // Handle case when date is cleared (null)
        if (newDate === null || newDate === '') {
          if (this.location.posnet_company_show_report) {
            const yesterdayDate = this.getYesterdayDate()
            swal({
              text: this.$t('posnet.confirmActivateReportAutomated', { date: yesterdayDate }) || `Are you sure you want to activate the report in automated mode for yesterday's date (${yesterdayDate})?`,
              type: 'question',
              showCancelButton: true,
              confirmButtonText: this.$t('general.yes'),
              cancelButtonText: this.$t('general.no')
            }).then((result) => {
              if (result) {
                this.loading = true
                const id = this.location.posnet_company_id
                var data = {
                  token: this.$session.get('token'),
                  location_id: this.location.true_id,
                  company_id: this.location.company_id,
                  active: this.location.posnet_company_show_report,
                  report_date: null
                }

                this.apiRequest('/posnet/v2/enable-report/' + id, 'POST', data, (response) => {
                  if (response.status) {
                    swal({
                      text: this.$t('general.success'),
                      type: 'success',
                      showConfirmButton: false
                    })
                    self.previousPosnetDate = null
                  } else {
                    swal({
                      text: this.$t('general.error'),
                      type: 'error',
                      showConfirmButton: false
                    })
                    // Revert the date change
                    self.$set(self.location, 'posnet_company_report_date', previousDate)
                  }
                  this.loading = false
                })
              } else {
                // User cancelled, revert the date change
                Vue.set(this.location, 'posnet_company_report_date', previousDate)
              }
            })
            .catch(() => {
              this.$set(this.location, 'posnet_company_report_date', previousDate)
            })
          } else {
            // Report is not enabled, just store null
            this.previousPosnetDate = null
          }
          return
        }

        // Handle case when date is set (not null)
        if (this.location.posnet_company_show_report && newDate) {
          // Only show confirmation if we have a previous date and it's different
          if (!previousDate || newDate === previousDate) {
            // Update stored date if not set
            if (!this.previousPosnetDate && newDate) {
              this.previousPosnetDate = newDate
            }
            return
          }

          swal({
            text: this.$t('posnet.confirmActivateReport', { date: newDate }),
            type: 'question',
            showCancelButton: true,
            confirmButtonText: this.$t('general.yes'),
            cancelButtonText: this.$t('general.no')
          }).then((result) => {
            if (result) {
              this.loading = true
              const id = this.location.posnet_company_id
              var data = {
                token: this.$session.get('token'),
                location_id: this.location.true_id,
                company_id: this.location.company_id,
                active: this.location.posnet_company_show_report,
                report_date: newDate
              }

              this.apiRequest('/posnet/v2/enable-report/' + id, 'POST', data, (response) => {
                if (response.status) {
                  swal({
                    text: this.$t('general.success'),
                    type: 'success',
                    showConfirmButton: false
                  })
                  self.previousPosnetDate = newDate
                } else {
                  swal({
                    text: this.$t('general.error'),
                    type: 'error',
                    showConfirmButton: false
                  })
                  // Revert the date change
                  self.$set(self.location, 'posnet_company_report_date', previousDate)
                }
                this.loading = false
              })
            } else {
              // User cancelled, revert the date change
              Vue.set(this.location, 'posnet_company_report_date', previousDate)
            }
          })
          .catch(() => {
            this.$set(this.location, 'posnet_company_report_date', previousDate)
          })
        } else {
          // Store the date for future reference
          if (newDate) {
            this.previousPosnetDate = newDate
          }
        }
      },
      addMoreBoltIntervals (dayIdx) {
        this.boltSchedule[dayIdx].intervals.push({
          start_at_minutes_from_midnight: null,
          stop_at_minutes_from_midnight: null
        })
      },
      deleteBoltIntervals (intervalKey, dayIdx) {
        this.boltSchedule[dayIdx].intervals.splice(intervalKey, 1)
      },
      createNexusOrders () {
        if (!this.nexusFrom || !this.nexusTo) {
          swal({
            text: this.$t('validations.requiredField'),
            type: 'warning',
            showCancelButton: false
          })
          return
        }
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          start: this.nexusFrom,
          end: this.nexusTo
        }

        this.apiRequest('/nexus/send-orders', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Sincronizarea a inceput. Finalizarea poate dura cateva minute.',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Sincronizarea nu poate fi realizata',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      cancelNexusOrders () {
        if (!this.nexusFrom || !this.nexusTo) {
          swal({
            text: this.$t('validations.requiredField'),
            type: 'warning',
            showCancelButton: false
          })
          return
        }
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          start: this.nexusFrom,
          end: this.nexusTo
        }

        this.apiRequest('/nexus/cancel-orders', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Sincronizarea a inceput. Finalizarea poate dura cateva minute',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Sincronizarea nu poate fi realizata',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      retryFailedOrders () {
        if (!this.nexusFrom || !this.nexusTo) {
          swal({
            text: this.$t('validations.requiredField'),
            type: 'warning',
            showCancelButton: false
          })
          return
        }
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          start: this.nexusFrom,
          end: this.nexusTo
        }

        this.apiRequest('/nexus/reset-failed-orders', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Sincronizarea a inceput. Finalizarea poate dura cateva minute',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Sincronizarea nu poate fi realizata',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      handleNexusToChange (value) {
        if (value && value.endsWith(' 00:00:00')) {
          this.$nextTick(() => {
            this.nexusTo = value.replace(' 00:00:00', ' 23:59:59')
          })
        }
      },
      syncEpRestaurantMenu (location, update = false) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }
        if (update) {
          data.update = true
        }
        this.apiRequest('/ep-restaurant/import-menu/' + location.ep_restaurant_id, 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      syncFreyaCloudMenu (location) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }

        this.apiRequest('/freya-cloud/import-products/' + location.freya_cloud_id, 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      updateLocationMapActive (value) {
        this.location.mapactive = value
      },
      syncGlovoMenu (location) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }
        this.apiRequest('/glovo/sync-menu', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: response.errorCode ? this.$t('glovo.' + response.errorCode) : 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      handleGlovoStatus () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          glovo_company_id: this.location.glovo_company_id,
          active: this.glovoStatus
        }

        this.apiRequest('/glovo/toggle-location-status', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('bolt.sync'),
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
            this.glovoStatus = !this.glovoStatus
          }
          this.loading = false
        })
      },
      updateGlovoMenu () {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: this.location.true_id,
          company_id: this.location.company_id,
          glovo_company_id: this.location.glovo_company_id
        }

        this.apiRequest('/glovo/menu/send-url', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: this.$t('bolt.sync'),
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: this.$t('bolt.syncError'),
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      // ---------------- RKeeper V2 (UNIConnector) ----------------
      ensureRkV2 (location) {
        if (location && !location.rkeeper_v2) {
          Vue.set(location, 'rkeeper_v2', {
            url: '',
            api_user: '',
            api_secret: '',
            restaurant_slug: '',
            active: false,
            login_ok: false,
            login_message: '',
            testing: false,
            saving: false,
            is_running: false,
            sync_status: 'idle',
            sync_message: '',
            loaded: false,
            _polling: false
          })
          this.loadRkV2(location)
        }
        return true
      },
      rkV2BaseData (location) {
        return {
          token: this.$session.get('token'),
          company_id: location.company_id,
          location_id: location.true_id
        }
      },
      loadRkV2 (location) {
        this.apiRequest('/integrations/rkeeper-v2/config', 'GET', this.rkV2BaseData(location), (response) => {
          if (response && response.status === true && response.data && response.data.config) {
            var c = response.data.config
            location.rkeeper_v2.url = c.url || ''
            location.rkeeper_v2.api_user = c.api_user || ''
            location.rkeeper_v2.api_secret = c.api_secret || ''
            location.rkeeper_v2.restaurant_slug = c.restaurant_slug || ''
            location.rkeeper_v2.active = !!c.active
            location.rkeeper_v2.login_ok = !!c.active
            location.rkeeper_v2.loaded = true
          }
          this.loadRkV2Status(location)
        })
      },
      loadRkV2Status (location) {
        this.apiRequest('/integrations/rkeeper-v2/sync-menu/status', 'GET', this.rkV2BaseData(location), (response) => {
          if (response && response.status === true && response.data) {
            this.applyRkV2Status(location, response.data)
          }
        })
      },
      applyRkV2Status (location, s) {
        location.rkeeper_v2.sync_status = s.menu_sync_status
        location.rkeeper_v2.is_running = !!s.is_running
        location.rkeeper_v2.sync_message = s.menu_sync_message || ''
        if (s.is_running && !location.rkeeper_v2._polling) {
          this.pollRkV2Status(location)
        }
      },
      pollRkV2Status (location) {
        location.rkeeper_v2._polling = true
        var self = this
        var tick = function () {
          self.apiRequest('/integrations/rkeeper-v2/sync-menu/status', 'GET', self.rkV2BaseData(location), (response) => {
            if (response && response.status === true && response.data) {
              var s = response.data
              location.rkeeper_v2.sync_status = s.menu_sync_status
              location.rkeeper_v2.is_running = !!s.is_running
              location.rkeeper_v2.sync_message = s.menu_sync_message || ''
              if (s.is_running) {
                setTimeout(tick, 3000)
              } else {
                location.rkeeper_v2._polling = false
              }
            } else {
              location.rkeeper_v2._polling = false
            }
          })
        }
        setTimeout(tick, 3000)
      },
      testRkV2Login (location) {
        location.rkeeper_v2.testing = true
        var data = this.rkV2BaseData(location)
        data.url = location.rkeeper_v2.url
        data.api_user = location.rkeeper_v2.api_user
        data.api_secret = location.rkeeper_v2.api_secret
        data.restaurant_slug = location.rkeeper_v2.restaurant_slug
        this.apiRequest('/integrations/rkeeper-v2/test-login', 'POST', data, (response) => {
          location.rkeeper_v2.testing = false
          var ok = response && response.status === true
          location.rkeeper_v2.login_ok = ok
          location.rkeeper_v2.login_message = ok
            ? this.$t('rkeeperV2.loginOk')
            : ((response && response.errors && response.errors[0]) ? response.errors[0] : this.$t('rkeeperV2.loginFail'))
          swal({ title: '', text: location.rkeeper_v2.login_message, type: ok ? 'success' : 'error', showConfirmButton: false, timer: 1800 })
        })
      },
      saveRkV2 (location) {
        location.rkeeper_v2.saving = true
        var data = this.rkV2BaseData(location)
        data.url = location.rkeeper_v2.url
        data.api_user = location.rkeeper_v2.api_user
        data.api_secret = location.rkeeper_v2.api_secret
        data.restaurant_slug = location.rkeeper_v2.restaurant_slug
        this.apiRequest('/integrations/rkeeper-v2/config', 'POST', data, (response) => {
          location.rkeeper_v2.saving = false
          var ok = response && response.status === true
          swal({ title: '', text: ok ? this.$t('rkeeperV2.saved') : this.$t('rkeeperV2.error'), type: ok ? 'success' : 'error', showConfirmButton: false, timer: 1500 })
        })
      },
      toggleRkV2Active (location) {
        var desired = location.rkeeper_v2.active
        var data = this.rkV2BaseData(location)
        data.active = desired ? 1 : 0
        this.apiRequest('/integrations/rkeeper-v2/active', 'POST', data, (response) => {
          var ok = response && response.status === true
          if (!ok) {
            location.rkeeper_v2.active = !desired // revert the checkbox
            var msg = (response && response.errors && response.errors[0]) ? response.errors[0] : this.$t('rkeeperV2.error')
            swal({ title: '', text: msg, type: 'error', showConfirmButton: false, timer: 2500 })
          } else {
            if (desired) {
              location.rkeeper_v2.login_ok = true
            }
            swal({ title: '', text: this.$t('rkeeperV2.saved'), type: 'success', showConfirmButton: false, timer: 1200 })
          }
        })
      },
      syncRkV2Menu (location) {
        this.apiRequest('/integrations/rkeeper-v2/sync-menu', 'POST', this.rkV2BaseData(location), (response) => {
          if (response && response.status === true) {
            location.rkeeper_v2.is_running = true
            location.rkeeper_v2.sync_status = 'pending'
            location.rkeeper_v2.sync_message = this.$t('rkeeperV2.syncQueued')
            this.pollRkV2Status(location)
          } else {
            var msg = (response && response.errors && response.errors[0]) ? response.errors[0] : this.$t('rkeeperV2.error')
            swal({ title: '', text: msg, type: 'error', showConfirmButton: false, timer: 2000 })
          }
        })
      },
      importCategories (location) {
        this.$nextTick(function () {
          this.loading = true
        })

        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }

        // Set a timeout to inform user if request takes too long
        let hasTimedOut = false
        const timeoutDuration = 30000 // 30 seconds
        const timeoutId = setTimeout(() => {
          hasTimedOut = true
          this.$nextTick(() => { this.loading = false })
          swal(
            {
              title: '',
              text: this.$t('rkeeper.importInProgress'),
              type: 'info',
              showConfirmButton: true,
              confirmButtonText: this.$t('reports.requestConfirm')
            }
          )
        }, timeoutDuration)

        this.apiRequest('/sync-categories-rkeeper', 'POST', data, (response) => {
          // Clear the timeout if response comes before timeout
          clearTimeout(timeoutId)

          // Only show success/error if we haven't timed out yet
          if (!hasTimedOut) {
            if (response.status === true) {
              swal(
                {
                  title: '',
                  text: this.$t('rkeeper.importSuccess'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              this.$nextTick(() => { this.loading = false })
            } else {
              swal(
                {
                  title: '',
                  text: this.$t('rkeeper.importError'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              this.$nextTick(() => { this.loading = false })
            }
          }
        })
      },
      importProducts (location, type = 0) {
        this.$nextTick(function () {
          this.loading = true
        })

        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }

        if (type === 1) {
          data.fetch_new_products_only = true
        } else if (type === 2) {
          data.fetch_new_options_only = true
        }

        // Set a timeout to inform user if request takes too long
        let hasTimedOut = false
        const timeoutDuration = 30000 // 30 seconds
        const timeoutId = setTimeout(() => {
          hasTimedOut = true
          this.$nextTick(() => { this.loading = false })
          swal(
            {
              title: '',
              text: this.$t('rkeeper.importInProgress'),
              type: 'info',
              showConfirmButton: true,
              confirmButtonText: this.$t('reports.requestConfirm')
            }
          )
        }, timeoutDuration)

        this.apiRequest('/sync-products-rkeeper', 'POST', data, (response) => {
          // Clear the timeout if response comes before timeout
          clearTimeout(timeoutId)

          // Only show success/error if we haven't timed out yet
          if (!hasTimedOut) {
            if (response.status === true) {
              swal(
                {
                  title: '',
                  text: this.$t('rkeeper.importSuccess'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              this.$nextTick(() => { this.loading = false })
            } else {
              swal(
                {
                  title: '',
                  text: this.$t('rkeeper.importError'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              this.$nextTick(() => { this.loading = false })
            }
          }
        })
      },
      syncProductPrices (location) {
        this.$nextTick(function () {
          this.loading = true
        })

        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }

        // Set a timeout to inform user if request takes too long
        let hasTimedOut = false
        const timeoutDuration = 30000 // 30 seconds
        const timeoutId = setTimeout(() => {
          hasTimedOut = true
          this.$nextTick(() => { this.loading = false })
          swal(
            {
              title: '',
              text: this.$t('rkeeper.syncInProgress'),
              type: 'info',
              showConfirmButton: true,
              confirmButtonText: this.$t('reports.requestConfirm')
            }
          )
        }, timeoutDuration)

        this.apiRequest('/sync-product-prices-rkeeper', 'POST', data, (response) => {
          // Clear the timeout if response comes before timeout
          clearTimeout(timeoutId)

          // Only show success/error if we haven't timed out yet
          if (!hasTimedOut) {
            if (response.status) {
              swal(
                {
                  title: '',
                  text: this.$t('rkeeper.syncSuccess'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              this.$nextTick(() => { this.loading = false })
            } else {
              swal(
                {
                  title: '',
                  text: this.$t('rkeeper.syncError'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              this.$nextTick(() => { this.loading = false })
            }
          }
        })
      },
      syncOptionPrices (location) {
        this.$nextTick(function () {
          this.loading = true
        })

        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }

        // Set a timeout to inform user if request takes too long
        let hasTimedOut = false
        const timeoutDuration = 30000 // 30 seconds
        const timeoutId = setTimeout(() => {
          hasTimedOut = true
          this.$nextTick(() => { this.loading = false })
          swal(
            {
              title: '',
              text: this.$t('rkeeper.syncInProgress'),
              type: 'info',
              showConfirmButton: true,
              confirmButtonText: this.$t('reports.requestConfirm')
            }
          )
        }, timeoutDuration)

        this.apiRequest('/sync-option-prices-rkeeper', 'POST', data, (response) => {
          // Clear the timeout if response comes before timeout
          clearTimeout(timeoutId)

          // Only show success/error if we haven't timed out yet
          if (!hasTimedOut) {
            if (response.status) {
              swal(
                {
                  title: '',
                  text: this.$t('rkeeper.syncSuccess'),
                  type: 'success',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              this.$nextTick(() => { this.loading = false })
            } else {
              swal(
                {
                  title: '',
                  text: this.$t('rkeeper.syncError'),
                  type: 'error',
                  showConfirmButton: false,
                  timer: 1500
                }
              )
              this.$nextTick(() => { this.loading = false })
            }
          }
        })
      },
      updateTazzMenu (location) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }
        this.apiRequest('/tazz/update-menu', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      updateProductPricesMagister (location) {
        this.loading = true
        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }
        this.apiRequest('/magister/sync-products', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      updateProductStocksMagister (location) {
        this.loading = true

        var data = {
          token: this.$session.get('token'),
          location_id: location.true_id,
          company_id: location.company_id
        }
        this.apiRequest('/magister/sync-stock', 'POST', data, (response) => {
          if (response.status) {
            swal({
              text: 'Success',
              type: 'success',
              showCancelButton: false
            })
          } else {
            swal({
              text: 'Error',
              type: 'error',
              showCancelButton: false
            })
          }
          this.loading = false
        })
      },
      updateVatPrinterId (obj, taxIndex) {
        const selectElement = obj.target
        const selectedOptionName = selectElement.options[selectElement.selectedIndex].getAttribute('data-name')

        this.location.taxes[taxIndex].name = selectedOptionName
        // this.model.locations_details[locIndex].taxes[taxIndex].name = selectedOptionName
      },
      getData () {
        this.deliveryMethods = this.getCompanyDetail('delivery_options_labels')
        this.timeFormat = this.getCompanyDetail('time_format')
        this.dateFormat = this.getCompanyDetail('date_format')
        this.sortMethodsList = this.defaultData.sort_products_methods || []
        var data = {
          token: this.$session.get('token')
        }
        this.requestInitialData('paymentGroups', '/settings/payment-groups/' + this.$session.get('selectedCompany'), data, (response) => {
          if (response.status === true) {
            if (response.data.length === 0) {
              this.paymentGroups = null
            } else {
              this.paymentGroups = response.data
            }
          }
        })
      },
      getLocationData () {
        var data = {
          token: this.$session.get('token')
        }

        if (this.id) {
          this.requestInitialData('location', '/admin/location/' + this.id, data, (response) => {
            if (response.status) {
              let respData = response.data
              if (!respData.tip_suggestion) {
                respData.tip_suggestion = {
                  type: 'proc',
                  values: [5, 10, 15, 0]
                }
              }
              respData.discount_suggestion = this.normalizeDiscountSuggestion(respData.discount_suggestion)
              if (respData.is_open === undefined || respData.is_open === null) {
                respData.is_open = true
              } else {
                respData.is_open = !!respData.is_open
              }
              if (!Array.isArray(respData.cross_sell_products)) {
                respData.cross_sell_products = []
              }
              if (respData.hide_from_platforms != null && !Array.isArray(respData.hide_from_platforms)) {
                throw new Error('Invalid location platform selection')
              }
              respData.hide_from_platforms = (respData.hide_from_platforms || []).map(Number)
              this.selectedHiddenPlatforms = this.locationPlatforms.filter(platform => respData.hide_from_platforms.indexOf(platform.id) !== -1)
              this.location = respData
              this.location.kiosk_allow_fidelities = this.companyLoyaltyInUse
                ? !!this.location.kiosk_allow_fidelities
                : false
              this.location.pos_display_tips_on_order = this.location.pos_display_tips_on_order === null || this.location.pos_display_tips_on_order === undefined
                ? true
                : !!this.location.pos_display_tips_on_order

              if (this.location.inv_is_vat_payer === null) {
                this.location.inv_is_vat_payer = 0
              }

              if (this.location.inv_fiscal_code && this.location.inv_fiscal_code.trim().length > 0) {
                this.inv_fiscal_code_disabled_field = true
              }

              // Set default date for posnet_company_report_date if not set
              if (this.location.posnet_company_id && !this.location.posnet_company_report_date) {
                this.location.posnet_company_report_date = this.getTodayDate()
              }

              // Store initial date for posnet report date tracking
              if (this.location.posnet_company_id) {
                this.previousPosnetDate = this.location.posnet_company_report_date || this.getTodayDate()
                this.previousPosnetSwitchState = this.location.posnet_company_show_report
              }

              if (!this.location.ordering_management) {
                this.location.ordering_management = this.createDefaultDeliveryMethods()
              }

              if (this.location.bolt_company_id) {
                this.apiRequest('/bolt/company/' + this.location.bolt_company_id, 'GET', data, (response) => {
                  if (response.status && response.data) {
                    this.boltStatus = response.data.active
                    this.boltSchedule = response.data.schedule
                  } else {
                    this.boltStatus = false
                    this.boltSchedule = [
                      {
                        'open': true,
                        'intervals': [{
                          'start_at_minutes_from_midnight': '10:00',
                          'stop_at_minutes_from_midnight': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'start_at_minutes_from_midnight': '10:00',
                          'stop_at_minutes_from_midnight': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'start_at_minutes_from_midnight': '10:00',
                          'stop_at_minutes_from_midnight': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'start_at_minutes_from_midnight': '10:00',
                          'stop_at_minutes_from_midnight': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'start_at_minutes_from_midnight': '10:00',
                          'stop_at_minutes_from_midnight': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'start_at_minutes_from_midnight': '10:00',
                          'stop_at_minutes_from_midnight': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'start_at_minutes_from_midnight': '10:00',
                          'stop_at_minutes_from_midnight': '22:00'
                        }]
                      }
                    ]
                  }
                })
              }

              if (this.location.wolt_company_id) {
                this.apiRequest('/wolt/company/' + this.location.wolt_company_id, 'GET', data, (response) => {
                  this.woltStatus = response.data.active
                  if (response.data.schedule.length) {
                    this.woltSchedule = response.data.schedule
                  } else {
                    this.woltSchedule = [
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      }
                    ]
                  }
                })
              }
              if (this.location.glovo_company_id) {
                this.apiRequest('/glovo/company/' + this.location.glovo_company_id, 'GET', data, (response) => {
                  if (response.status && response.data) {
                    this.glovoStatus = response.data.store_active
                  } else {
                    this.glovoStatus = false
                  }
                })
              }

              if (this.location.wolt_company_id) {
                this.apiRequest('/wolt/company/' + this.location.wolt_company_id, 'GET', data, (response) => {
                  this.woltStatus = response.data.active
                  if (response.data.schedule.length) {
                    this.woltSchedule = response.data.schedule
                  } else {
                    this.woltSchedule = [
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      },
                      {
                        'open': true,
                        'intervals': [{
                          'opening_time': '10:00',
                          'closing_time': '22:00'
                        }]
                      }
                    ]
                  }
                })
              }

              this.displayIntegrationCard = true

              if (!this.location.r_system_company) {
                this.location.r_system_company = {
                  api_key: null,
                  organization_id: null,
                  terminal_group_id: null,
                  discount_pos_id: null,
                  payment_types: ''
                }
              }
            }
          })
        } else {
          this.addLocation()
        }
      },
      addLocation () {
        var data = {
          'token': this.$session.get('token'),
          'type': 'hashes'
        }

        this.requestInitialData('location', '/helpers', data, (response) => {
          if (response.status) {
            let newRow = {
              id: null,
              city: '',
              country: '',
              email: null,
              name: null,
              is_open: true,
              taxes: [],
              vat: [],
              image: null,
              use_dynamic_menu: 1,
              allow_open_order: false,
              kiosk_is_using_top_category: false,
              kiosk_is_using_fiscal_receipt_for_cash: false,
              kiosk_is_using_non_fiscal_receipt_for_card: false,
              kiosk_add_to_cart_notification_position: 1,
              kiosk_allow_fidelities: false,
              allow_pos_use_coupons: 0,
              pos_confirm_order_close_on_method_select: 0,
              pos_display_all_product_options: 0,
              pos_allow_group_products: 1,
              force_credit_for_integration_cash_orders: 0,
              pos_use_yumm_voucher: false,
              pos_use_stock: false,
              pos_ask_storno_back_in_stock: false,
              pos_keep_first_waiter_id_order_split: false,
              pos_display_tips_on_order: true,
              pos_default_course_count: 0,
              pos_always_set_client: 5,
              inv_is_vat_payer: 0,
              inv_bank_account: null,
              inv_bank: null,
              inv_bank_branch: null,
              ordering_management: [
                {
                  type: 'pick_up',
                  label: 'Pick-up',
                  enabled: false,
                  offset: 0,
                  period: 1,
                  is_always_open: false,
                  is_always_open_preorder_hours: 0,
                  minimum_order_value: 0,
                  default_waiting_time: 0,
                  available_days: [],
                  payment_options: {cash: false, credit_card: false, pos: false},
                  delivery_hour_usage: 0,
                  hour_and_date_delivery_hour_usage: 1,
                  allow_fidelities: 1,
                  allow_sms_notifications: 1
                },
                {
                  type: 'meet_half',
                  label: 'Meet me half way',
                  enabled: false,
                  offset: 0,
                  period: 1,
                  is_always_open: false,
                  is_always_open_preorder_hours: 0,
                  minimum_order_value: 0,
                  default_waiting_time: 0,
                  available_days: [],
                  payment_options: {cash: false, credit_card: false, pos: false},
                  locations: [],
                  delivery_hour_usage: 0,
                  hour_and_date_delivery_hour_usage: 1,
                  allow_fidelities: 1,
                  allow_sms_notifications: 1
                },
                {
                  type: 'delivery',
                  label: 'Delivery',
                  area: 'radius',
                  delivery_rules: [{'subrules': [{'cities': [], 'neighborhoods': [], 'shipping_cost': 0, 'min_order_value': 0, 'shipping_pos_id': null}], 'shipping_cost': 0, 'delivery_range': '1000', 'shipping_pos_id': []}],
                  enabled: false,
                  offset: 0,
                  period: 1,
                  is_always_open: false,
                  is_always_open_preorder_hours: 0,
                  minimum_order_value: 0,
                  default_waiting_time: 0,
                  available_days: [],
                  payment_options: {cash: false, credit_card: false, pos: false},
                  cost: null,
                  shipping_cost: [],
                  delivery_hour_usage: 0,
                  hour_and_date_delivery_hour_usage: 1,
                  allow_fidelities: 1,
                  allow_sms_notifications: 1
                },
                {
                  type: 'eat_location',
                  label: 'Eat on location',
                  enabled: false,
                  offset: 0,
                  period: 1,
                  is_always_open: false,
                  is_always_open_preorder_hours: 0,
                  min_reservation: 1,
                  max_reservation: 5,
                  max_number_seats: null,
                  min_between_reservations: 15,
                  min_standard_reservations: 60,
                  reservations_intervals: [2],
                  minimum_order_value: 0,
                  default_waiting_time: 0,
                  available_days: [],
                  payment_options: {cash: false, credit_card: false, pos: false},
                  delivery_hour_usage: 0,
                  hour_and_date_delivery_hour_usage: 1,
                  reservation_taxes: [],
                  allow_fidelities: 1,
                  allow_sms_notifications: 1
                },
                {
                  type: 'self_ordering',
                  label: 'Self Ordering',
                  enabled: false,
                  offset: 0,
                  period: 1,
                  is_always_open: false,
                  is_always_open_preorder_hours: 0,
                  minimum_order_value: 0,
                  default_waiting_time: 0,
                  available_days: [],
                  max_distance_in_meter: 50,
                  payment_options: {cash: false, credit_card: false, pos: false, kiosk_pos: false},
                  delivery_hour_usage: 0,
                  hour_and_date_delivery_hour_usage: 1,
                  allow_fidelities: 1,
                  allow_sms_notifications: 1
                }
              ],
              phone: null,
              street: null,
              number: null,
              tip_suggestion: {
                type: 'proc',
                values: [
                  5, 10, 15, 0
                ]
              },
              reorder_popup_minutes: null,
              cross_sell_products: [],
              discount_suggestion: {
                fix: [5, 10, 15, 0],
                proc: [5, 10, 15, 0]
              },
              working_hours: []
              // allow_preorder: false
            }
            // newRow = self.newLocation
            newRow.id = response.data[0].id

            newRow.isNew = true

            for (let iDay in this.days) {
              // newRow.working_hours.push({day: self.days[iDay], open_to: '', open_from: '', open: false, preorder_from: ''})
              newRow.working_hours.push({day: this.days[iDay], open_to: '22:00', open_from: '10:00', open: true})
            }

            for (let iOrder in newRow.ordering_management) {
              for (let iDay in this.days) {
                newRow.ordering_management[iOrder].available_days.push({day: this.days[iDay], open_to: '22:00', open_from: '10:00', open: true})
              }
            }
            this.selectedHiddenPlatforms = []
            newRow.hide_from_platforms = []
            this.location = newRow
          } else {
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      getTodayDate () {
        const today = new Date()
        const year = today.getFullYear()
        const month = String(today.getMonth() + 1).padStart(2, '0')
        const day = String(today.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },
      getYesterdayDate () {
        const yesterday = new Date()
        yesterday.setDate(yesterday.getDate() - 1)
        const year = yesterday.getFullYear()
        const month = String(yesterday.getMonth() + 1).padStart(2, '0')
        const day = String(yesterday.getDate()).padStart(2, '0')
        return `${year}-${month}-${day}`
      },
      createDefaultDeliveryMethods () {
        let newRow = [
          {
            type: 'pick_up',
            label: 'Pick-up',
            enabled: false,
            offset: 0,
            period: 1,
            is_always_open: false,
            is_always_open_preorder_hours: 0,
            minimum_order_value: 0,
            default_waiting_time: 0,
            available_days: [],
            payment_options: {cash: false, credit_card: false, pos: false},
            delivery_hour_usage: 0,
            hour_and_date_delivery_hour_usage: 1
          },
          {
            type: 'meet_half',
            label: 'Meet me half way',
            enabled: false,
            offset: 0,
            period: 1,
            is_always_open: false,
            is_always_open_preorder_hours: 0,
            minimum_order_value: 0,
            default_waiting_time: 0,
            available_days: [],
            payment_options: {cash: false, credit_card: false, pos: false},
            locations: [],
            delivery_hour_usage: 0,
            hour_and_date_delivery_hour_usage: 1,
            allow_fidelities: 1,
            allow_sms_notifications: 1
          },
          {
            type: 'delivery',
            label: 'Delivery',
            area: 'radius',
            delivery_rules: [{'subrules': [{'cities': [], 'neighborhoods': [], 'shipping_cost': 0, 'min_order_value': 0, 'shipping_pos_id': null}], 'shipping_cost': 0, 'delivery_range': '1000', 'shipping_pos_id': []}],
            enabled: false,
            offset: 0,
            period: 1,
            is_always_open: false,
            is_always_open_preorder_hours: 0,
            minimum_order_value: 0,
            default_waiting_time: 0,
            available_days: [],
            payment_options: {cash: false, credit_card: false, pos: false},
            cost: null,
            shipping_cost: [],
            delivery_hour_usage: 0,
            hour_and_date_delivery_hour_usage: 1,
            allow_fidelities: 1,
            allow_sms_notifications: 1
          },
          {
            type: 'eat_location',
            label: 'Eat on location',
            enabled: false,
            offset: 0,
            period: 1,
            is_always_open: false,
            is_always_open_preorder_hours: 0,
            min_reservation: 1,
            max_reservation: 5,
            max_number_seats: null,
            min_between_reservations: 15,
            min_standard_reservations: 60,
            reservations_intervals: [2],
            minimum_order_value: 0,
            default_waiting_time: 0,
            available_days: [],
            payment_options: {cash: false, credit_card: false, pos: false},
            delivery_hour_usage: 0,
            hour_and_date_delivery_hour_usage: 1,
            reservation_taxes: [],
            allow_fidelities: 1,
            allow_sms_notifications: 1
          },
          {
            type: 'self_ordering',
            label: 'Self Ordering',
            enabled: false,
            offset: 0,
            period: 1,
            is_always_open: false,
            is_always_open_preorder_hours: 0,
            minimum_order_value: 0,
            default_waiting_time: 0,
            available_days: [],
            max_distance_in_meter: 50,
            payment_options: {cash: false, credit_card: false, pos: false, kiosk_pos: false},
            delivery_hour_usage: 0,
            hour_and_date_delivery_hour_usage: 1,
            allow_fidelities: 1,
            allow_sms_notifications: 1
          }
        ]

        for (let iOrder in newRow) {
          for (let iDay in this.days) {
            newRow[iOrder].available_days.push({day: this.days[iDay], open_to: '22:00', open_from: '10:00', open: true})
          }
        }

        return newRow
      },
      getLocations () {
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          columns: ['id', 'token', 'name', 'email', 'street', 'phone']
        }

        this.requestInitialData('locations', '/locations', data, response => {
          if (response.status) {
            this.allLocations = response.data
          }
        })
      },
      checkVal (location) {
        // console.warn(location.allow_preorder)
      },
      clearIntegratorsPrinterErrorWhenOptional () {
        if (!this.location || !this.errors) {
          return
        }
        const rules = this.integratorsTaxVatPrinterRules
        if (!rules || !Object.keys(rules).length) {
          if (this.errors.has('integrators_tax_vat_printer_id')) {
            this.errors.remove('integrators_tax_vat_printer_id')
          }
        }
      },
      clearOtherTaxesVatPrinterErrorWhenOptional () {
        if (!this.location || !this.errors) {
          return
        }
        const rules = this.otherTaxesVatPrinterRules
        if (!rules || !Object.keys(rules).length) {
          if (this.errors.has('other_taxes_vat_printer_id')) {
            this.errors.remove('other_taxes_vat_printer_id')
          }
        }
      },
      clearDonationVatPrinterErrorWhenOptional () {
        if (!this.location || !this.errors) {
          return
        }
        const rules = this.donationVatPrinterRules
        if (!rules || !Object.keys(rules).length) {
          if (this.errors.has('donation_vat_printer_id')) {
            this.errors.remove('donation_vat_printer_id')
          }
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      localizedValidatorMessage (fieldName) {
        if (!this.errors.has(fieldName)) {
          return ''
        }
        const err = this.errors.items.find(e => e.field === fieldName)
        if (!err) {
          return this.getError(fieldName)
        }
        if (err.rule === 'required') {
          return this.$t('validations.requiredField')
        }
        if (err.rule === 'numeric') {
          return this.$t('validations.vatPrinterIdNumeric')
        }
        if (err.rule === 'min_value' || err.rule === 'max_value') {
          return this.$t('validations.vatPrinterIdRange')
        }
        return this.getError(fieldName)
      },
      vatPrinterFieldName (taxRate, vatIndex) {
        const idPart = (taxRate.id !== null && taxRate.id !== undefined) ? String(taxRate.id) : 'n' + vatIndex
        return 'vat_printer_' + idPart
      },
      validate (pageId) {
        if (this.loading || this.rSystemBusy || this.initialLoadError || !this.location) {
          return
        }
        this.$refs.deliveryMethods.validate().then(areDeliveryMethodsValid => {
          if (!areDeliveryMethodsValid) {
            this.hasDeliveryMethodsErrors = true
            return
          }
          this.$validator.validateAll().then(isValid => {
            if (isValid) {
              this.hasDeliveryMethodsErrors = false
              const deliveryMethodsData = this.$refs.deliveryMethods.getDeliveryMethodsDataToSave()
              this.loading = true
              const integration = this.$refs.rSystemSetup
              const saveIntegration = integration ? integration.saveIfDirty() : Promise.resolve(true)
              saveIntegration.then(saved => {
                if (!saved) {
                  this.loading = false
                  return
                }
                this.saveDetails(deliveryMethodsData)
              }).catch(() => {
                this.loading = false
              })
              this.hasLocationErrors = false
              this.hasPaymentGroupErrors = false
              this.hasVatErrors = false
            } else {
              if (this.$validator.errors.items.some(item => item.field === 'name' || item.field === 'email' || item.field === 'phone' || item.field === 'country' || item.field === 'state' || item.field === 'city' || item.field === 'street' || item.field === 'street-number')) {
                this.hasLocationErrors = true
              } else {
                this.hasLocationErrors = false
              }
              this.hasVatErrors = this.$validator.errors.items.some(item => item.field && item.field.indexOf('vat_printer_') === 0)
              if (this.$validator.errors.items.some(item => item.field === 'paymentGroups' || item.field === 'integrators_tax_vat_printer_id' || item.field === 'other_taxes_vat_printer_id' || item.field === 'donation_vat_printer_id')) {
                this.hasPaymentGroupErrors = true
              } else {
                this.hasPaymentGroupErrors = false
              }
              if (this.hasLocationErrors) return this.scrollToSection('start')
              if (this.hasVatErrors) return this.scrollToSection('vat')
              if (this.hasPaymentGroupErrors) return this.scrollToSection('printer')
            }
          })
        })
      },
      doHeightCalculation () {
        this.windowHeight = window.innerHeight
        // this.navbarHeaderHeight = this.$refs.navbarHeader.clientHeight
        if (this.$refs.navButtons) {
          this.navButtonsHeight = this.$refs.navButtons.offsetHeight + 10 // margin-top = 10
        }
      },
      showStateDrop (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)

        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          return true
        } else {
          return false
        }
      },
      getStatesOptions (location) {
        var countryIso = location.country
        var countries = this.$session.get('defaultData').countries
        var countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)

        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          return countries[countryIdx].states
        } else {
          return []
        }
      },
      updateCountry (location) {
        location.state = null
        location.state_id = null
      },
      disableTaxOption (locId, taxId) {
        let thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.location['taxes'])

        if (thisTaxIdx !== false) {
          return true
        } else {
          return false
        }
      },
      disableVatOption (taxId) {
        let thisTaxIdx = this.getObjectByElemKeyValue('tax_id', taxId, this.location['vat'])

        if (thisTaxIdx !== false) {
          return true
        } else {
          return false
        }
      },
      deleteLocation (id) {
        var btnCounter = 3
        var self = this
        var companyID = this.$session.get('selectedCompany')

        var data = {
          token: this.$session.get('token'),
          company_id: companyID,
          location_id: id
        }

        this.apiRequest('/settings/can-delete-location', 'POST', data, function (response) {
          if (response.status === true) {
            // location ca be deleted
            swal({
              text: self.$t('settingCompany.areYouSureDelete'),
              type: 'question',
              showCancelButton: true,
              confirmButtonText: 'Yes (' + btnCounter + ')'
            })
            .then((result) => {
              if (result) {
                self.apiRequest('/delete-location', 'POST', data, function (response) {
                  swal({'text': self.$t('settingCompany.companyProdDeleted'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
                  this.backButton()
                })
              }
            })
            swal.disableConfirmButton()

            var btnInterval = setInterval(function () {
              btnCounter--

              if (btnCounter >= 1) {
                swal.getConfirmButton().textContent = 'Yes (' + btnCounter + ')'
              } else {
                swal.getConfirmButton().textContent = 'Yes'
                clearInterval(btnInterval)
                swal.enableConfirmButton()
              }
            }, 1000)
          } else if (response.status === false && response.errors.location_ids !== undefined) {
            swal({'text': self.$t('settingCompany.deleteLocationValidation'), 'type': 'error'}).catch(() => {})
          } else {
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      copyProducts () {
        let copyFrom = this.$refs['copyFrom'].value

        var data = {
          copy_to: this.location.id,
          copy_from: copyFrom,
          token: this.$session.get('token')
        }

        this.apiRequest('/locations/duplicate-products', 'POST', data, (response) => {
          if (response.status === true) {
            swal({'text': this.$t('settingCompany.companyProdCopied'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          } else {
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      addLocationToProducts () {
        let copyFrom = this.$refs['copyFrom'].value

        var data = {
          copy_to: this.location.id,
          copy_from: copyFrom,
          token: this.$session.get('token')
        }

        this.apiRequest('/locations/add-locations-products', 'POST', data, (response) => {
          if (response.status === true) {
            swal({'text': this.$t('settingCompany.companyProdAddLoc'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          } else {
            swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      deleteProducts (id) {
        let self = this
        var data = {
          location: id,
          token: self.$session.get('token')
        }
        swal({
          text: self.$t('settingCompany.areYouSureDeleteProd'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then((result) => {
          if (result) {
            self.apiRequest('/locations/delete-products', 'POST', data, (response) => {
              if (response.status === true) {
                swal({'text': self.$t('settingCompany.companyProdDeleted'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
              } else {
                swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
              }
            })
          }
        })
      },
      addNewTax (locId) {
        let newRow = {
          'id': null,
          'type': null,
          'amount': null
        }
        this.location['taxes'].push(newRow)
        this.showUpdateWarning = true
      },
      addNewVat () {
        let newRow = {
          'id': null,
          'company_id': this.$session.get('selectedCompany'),
          'location_id': this.location.true_id,
          'location_token': this.location.token,
          'tax_id': null,
          'type': 'PERCENTAGE_EXCLUDED',
          'amount': null,
          'printer_id': null,
          'is_vat': true
        }
        this.location.vat.push(newRow)
        this.showUpdateWarning = true
      },
      deleteTax (locId, taxId) {
        var self = this
        swal({
          text: self.$t('settingCompany.areYouSureTax'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then((result) => {
          if (result) {
            let thisTaxIdx = this.getObjectByElemKeyValue('id', taxId, this.location['taxes'])
            this.location['taxes'].splice(thisTaxIdx, 1)
            this.showUpdateWarning = true
          }
        })
        .catch({})
      },
      deleteVat (taxId, vatIndex) {
        if (!taxId) {
          this.location['vat'].splice(vatIndex, 1)
          return
        }
        var self = this
        swal({
          text: self.$t('settingCompany.areYouSureVat'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: 'Yes'
        })
        .then((result) => {
          if (result) {
            var data = {
              'token': this.$session.get('token')
            }
            this.apiRequest('/location/vat/delete/' + taxId, 'DELETE', data, (response) => {
              if (response.status) {
                this.location['vat'].splice(vatIndex, 1)
                swal({'text': this.$t('vat.deleteVatSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000})
              } else {
                swal({'text': this.$t('vat.deleteVatError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000})
              }
            })
            this.showUpdateWarning = true
          }
        })
        .catch({})
      },
      handleDelete () {
        var btnCounter = 3
        var self = this
        var companyID = this.$session.get('selectedCompany')

        var data = {
          token: this.$session.get('token'),
          company_id: companyID,
          location_id: this.location.token,
          true_id: this.location.true_id
        }

        this.apiRequest('/settings/can-delete-location', 'POST', data, (response) => {
          if (response.status === true) {
            // location ca be deleted
            swal({
              text: self.$t('settingCompany.areYouSureDelete'),
              type: 'question',
              showCancelButton: true,
              confirmButtonText: this.$t('general.yes') + ' (' + btnCounter + ')'
            })
            .then((result) => {
              if (result) {
                this.loading = true
                self.apiRequest('admin/location/' + this.location.true_id, 'DELETE', data, (response) => {
                  if (response.status) {
                    const locId = this.location.true_id
                    self.trackAdminEvent('ADMIN_LOCATION_DELETED', 'location', locId, {
                      location_id: locId,
                      name: (this.location && this.location.name) || (this.model && this.model.name) || null
                    })
                    this.getLocations()
                    this.loading = false
                    swal({
                      text: 'Sucess!',
                      type: 'success',
                      showConfirmButton: false,
                      timer: 1000
                    })
                    this.backButton()
                  }
                })
              }
            })
            swal.disableConfirmButton()

            var btnInterval = setInterval(function () {
              btnCounter--

              if (btnCounter >= 1) {
                swal.getConfirmButton().textContent = 'Yes (' + btnCounter + ')'
              } else {
                swal.getConfirmButton().textContent = 'Yes'
                clearInterval(btnInterval)
                swal.enableConfirmButton()
              }
            }, 1000)
          } else if (response.status === false && response.errors.location_ids !== undefined) {
            swal({'text': self.$t('settingCompany.deleteLocationValidation'), 'type': 'error'}).catch(() => {})
          } else {
            swal({'text': self.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
          }
        })
      },
      generateCode () {
        var data = {
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany')
        }
        this.apiRequest('/admin/generate-location-code/' + this.location.true_id, 'POST', data, (response) => {
          if (response.status) {
            this.location.auth_code = response.data.auth_code
            this.location.auth_qr_code = response.data.auth_qr_code
          }
        })
      },
      saveDetails (deliveryMethodsData) {
        this.$nextTick(function () { this.loading = true })
        var countries = this.$session.get('defaultData').countries

        let countryIso = this.location.country
        let countryIdx = this.getObjectByElemKeyValue('alpha2', countryIso, countries)
        let states = []

        if (countries[countryIdx] !== undefined && countries[countryIdx].states.length) {
          states = countries[countryIdx].states
        }

        if (states.length && this.location.state_id) {
          var state = this.getObjectByElemKeyValue('id', this.location.state_id, states)
          if (state !== undefined) {
            this.location.state = states[state].name
          } else {
            this.location.state = ''
          }
        }
        // let copy = this.copyObject(this.location)

        let copy = {
          active: this.location.active,
          is_open: this.location.is_open === undefined || this.location.is_open === null ? true : !!this.location.is_open,
          hide_from_platforms: this.selectedHiddenPlatforms.map(platform => platform.id),
          allow_preorder: this.location.allow_preorder,
          allow_open_order: this.location.allow_open_order,
          kiosk_is_using_top_category: this.location.kiosk_is_using_top_category,
          kiosk_is_using_fiscal_receipt_for_cash: this.location.kiosk_is_using_fiscal_receipt_for_cash,
          kiosk_is_using_non_fiscal_receipt_for_card: this.location.kiosk_is_using_non_fiscal_receipt_for_card,
          kiosk_add_to_cart_notification_position: this.location.kiosk_add_to_cart_notification_position || 1,
          kiosk_allow_fidelities: this.companyLoyaltyInUse ? !!this.location.kiosk_allow_fidelities : false,
          app_link: this.location.app_link,
          app_qr: this.location.app_qr,
          auto_print: this.location.auto_print,
          auto_print_local_server: !!this.location.auto_print_local_server,
          allow_pos_use_coupons: this.location.allow_pos_use_coupons,
          pos_confirm_order_close_on_method_select: this.location.pos_confirm_order_close_on_method_select,
          pos_display_all_product_options: this.location.pos_display_all_product_options,
          pos_allow_group_products: this.location.pos_allow_group_products,
          force_credit_for_integration_cash_orders: this.location.force_credit_for_integration_cash_orders,
          pos_use_yumm_voucher: !!this.location.pos_use_yumm_voucher,
          pos_use_stock: !!this.location.pos_use_stock,
          pos_ask_storno_back_in_stock: !!this.location.pos_ask_storno_back_in_stock,
          pos_keep_first_waiter_id_order_split: !!this.location.pos_keep_first_waiter_id_order_split,
          pos_display_tips_on_order: !!this.location.pos_display_tips_on_order,
          pos_default_course_count: this.location.pos_default_course_count,
          pos_always_set_client: this.location.pos_always_set_client,
          staff_food_daily_budget: this.location.staff_food_daily_budget,
          city: this.location.city,
          company_id: this.location.company_id,
          country: this.location.country,
          custom_sort_order: this.location.custom_sort_order,
          drcarmen_active: this.location.drcarmen_active,
          drcarmen_api_key: this.location.drcarmen_api_key,
          drcarmen_delay: this.location.drcarmen_delay,
          drcarmen_is_auto: this.location.drcarmen_is_auto,
          drcarmen_url: this.location.drcarmen_url,
          dynamic_menu_banner: this.location.dynamic_menu_banner,
          dynamic_menu_logo: this.location.dynamic_menu_logo,
          inv_company_name: this.location.inv_company_name,
          inv_fiscal_code: this.location.inv_fiscal_code,
          inv_trade_register: this.location.inv_trade_register,
          inv_phone: this.location.inv_phone,
          inv_email: this.location.inv_email,
          inv_address: this.location.inv_address,
          inv_street_number: this.location.inv_street_number,
          inv_country: this.location.inv_country,
          inv_county: this.location.inv_county,
          inv_city: this.location.inv_city,
          inv_additional_data: this.location.inv_additional_data,
          inv_is_vat_payer: this.location.inv_is_vat_payer,
          inv_bank_account: this.location.inv_bank_account,
          inv_bank: this.location.inv_bank,
          inv_bank_branch: this.location.inv_bank_branch,
          dynamic_menu_url: this.location.dynamic_menu_url,
          dynamic_qr_code: this.location.dynamic_qr_code,
          email: this.location.email,
          email_transport: this.location.email_transport,
          holiday_is_active: this.location.holiday_is_active,
          holiday_is_active_from: this.location.holiday_is_active_from,
          holiday_is_active_to: this.location.holiday_is_active_to,
          id: this.location.id,
          id_discount_pos: this.location.id_discount_pos,
          image: this.location.image,
          lat: this.location.lat,
          lng: this.location.lng,
          mapactive: this.location.mapactive,
          name: this.location.name,
          number: this.location.number,
          payment_group: this.location.payment_group,
          phone: this.location.phone,
          printer_ip: this.location.printer_ip,
          printer_port: this.location.printer_port,
          qr_code: this.location.qr_code,
          qr_code_url: this.location.qr_code_url,
          selected_group: this.location.selected_group,
          smartbill_add_to_cc: this.location.smartbill_add_to_cc,
          smartbill_api_key: this.location.smartbill_api_key,
          smartbill_cif: this.location.smartbill_cif,
          smartbill_email: this.location.smartbill_email,
          smartbill_send_auto: this.location.smartbill_send_auto,
          smartbill_series: this.location.smartbill_series,
          smartbill_status: this.location.smartbill_status,
          state: this.location.state,
          state_id: this.location.state_id,
          street: this.location.street,
          taxes: this.location.taxes,
          vat: this.location.vat,
          tip_suggestion: this.location.tip_suggestion,
          reorder_popup_minutes: this.location.reorder_popup_minutes,
          cross_sell_products: Array.isArray(this.location.cross_sell_products) ? this.location.cross_sell_products : [],
          discount_suggestion: this.normalizeDiscountSuggestion(this.location.discount_suggestion),
          use_dynamic_menu: this.location.use_dynamic_menu,
          use_printer: this.location.use_printer,
          use_twilio: this.location.use_twilio,
          use_twilio_early_mark: this.location.use_twilio_early_mark,
          twilio_phone: this.location.twilio_phone,
          time__prod_opt_report: this.location.time__prod_opt_report,
          email__prod_opt_report: this.location.email__prod_opt_report,
          integrators_department_id: this.location.integrators_department_id,
          integrators_tax_vat_printer_id: this.location.integrators_tax_vat_printer_id,
          integrators_tax_vat_amount: this.location.integrators_tax_vat_amount,
          other_taxes_vat_printer_id: this.location.other_taxes_vat_printer_id,
          donation_vat_printer_id: this.location.donation_vat_printer_id,
          google_maps_api_key: this.location.google_maps_api_key,
          wolt_drive_errors_url: this.location.wolt_drive_errors_url
        }

        // delete copy.states
        // delete copy.ordering_management

        var data = {
          'token': this.$session.get('token'),
          'company_id': this.$session.get('selectedCompany'),
          'locationData': copy
        }

        if (this.location.true_id) {
          this.apiRequest('/admin/location/' + this.location.true_id, 'PUT', data, (response) => {
            this.$nextTick(function () { this.loading = false })
            if (response.status) {
              const locId = response.data.true_id || this.location.true_id
              this.trackAdminEvent('ADMIN_LOCATION_UPDATE', 'location', locId, {
                location_id: locId,
                name: copy.name || null,
                request: data,
                response: response
              })
              deliveryMethodsData.location_token = response.data.token
              deliveryMethodsData.location_id = response.data.true_id
              this.syncCompanySessionAndCache()
              this.saveDeliveryMethods(deliveryMethodsData)
              this.backButton()
              swal({'text': this.$t('settingCompany.locationUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            } else {
              swal({'text': this.$t('settingCompany.updateError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            }
          })
        } else {
          data.locationData.active = true
          data.locationData.is_open = true
          this.apiRequest('/admin/location/', 'POST', data, (response) => {
            this.$nextTick(function () { this.loading = false })
            if (response.status) {
              const locId = response.data.true_id || null
              this.trackAdminEvent('ADMIN_LOCATION_UPDATE', 'location', locId, {
                location_id: locId,
                name: copy.name || null,
                request: data,
                response: response
              })
              deliveryMethodsData.location_token = response.data.token
              deliveryMethodsData.location_id = response.data.true_id
              this.syncCompanySessionAndCache()
              this.saveDeliveryMethods(deliveryMethodsData)
              this.backButton()
              swal({'text': this.$t('settingCompany.locationUpdated'), 'type': 'success', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            } else {
              swal({'text': this.$t('settingCompany.updateError'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            }
          })
        }
      },
      saveDeliveryMethods (data) {
        const trackDeliverySave = (response) => {
          const locId = data.location_id || (this.location && this.location.true_id) || null
          const methods = data.delivery_methods || []
          methods.forEach((method) => {
            const methodId = method.id || method.type
            this.trackAdminEvent('ADMIN_LOCATION_DELIVERY_METHOD_UPDATE', 'delivery_method', methodId, {
              delivery_method_id: methodId,
              location_id: locId,
              delivery_method_type: method.type || null,
              enabled: !!method.enabled,
              request: data,
              response: response
            })
          })
          if (!methods.length) {
            this.trackAdminEvent('ADMIN_LOCATION_DELIVERY_METHOD_UPDATE', 'delivery_method', locId, {
              location_id: locId,
              request: data,
              response: response
            })
          }
        }
        if (this.id) {
          this.apiRequest('/admin/delivery-methods', 'PUT', data, (response) => {
            if (response.status === true) {
              trackDeliverySave(response)
              this.$nextTick(() => {
                this.loading = false
              })
              swal({'text': this.$t('settingsOrdering.saveSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 3000}).catch(() => {})
            } else {
              this.$nextTick(() => { this.loading = false })
              swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            }
          })
        } else {
          this.apiRequest('/admin/delivery-methods', 'POST', data, (response) => {
            if (response.status === true) {
              trackDeliverySave(response)
              this.$nextTick(() => {
                this.loading = false
              })
              swal({'text': this.$t('settingsOrdering.saveSuccess'), 'type': 'success', 'showConfirmButton': false, 'timer': 3000}).catch(() => {})
            } else {
              this.$nextTick(() => { this.loading = false })
              swal({'text': this.$t('validations.wentWrong'), 'type': 'error', 'showConfirmButton': false, 'timer': 2000}).catch(() => {})
            }
          })
        }
      },
      goToCompany () {
        swal({
          text: this.$t('general.leavePageQuestion'),
          type: 'question',
          showCancelButton: true,
          confirmButtonText: this.$t('general.yes'),
          cancelButtonText: this.$t('general.cancel2')
        })
        .then((result) => {
          if (result) {
            this.backButton()
            this.$session.set('selectedTab', this.$t('settingsPages.taxLabeling'))
          }
        })
      },
      handleMenu (event) {
        this.location.use_dynamic_menu = event.target.value
      },
      handleTipType (event) {
        this.location.tip_suggestion.type = event.target.value
      },
      normalizeDiscountSuggestion (discountSuggestion) {
        const defaults = {
          fix: [5, 10, 15, 0],
          proc: [5, 10, 15, 0]
        }
        if (!discountSuggestion) {
          return defaults
        }
        if (Array.isArray(discountSuggestion.fix) && Array.isArray(discountSuggestion.proc)) {
          return {
            fix: discountSuggestion.fix,
            proc: discountSuggestion.proc
          }
        }
        // Legacy shape: { type, values }
        if (Array.isArray(discountSuggestion.values)) {
          return {
            fix: discountSuggestion.type === 'fix' ? discountSuggestion.values : defaults.fix.slice(),
            proc: discountSuggestion.type === 'proc' ? discountSuggestion.values : defaults.proc.slice()
          }
        }
        return defaults
      },
      downloadForm () {
        // Template download is handled by the anchor href (empty CSV headers).
      },
      openImportHistory () {
        if (!this.location || !this.location.true_id) {
          return
        }
        this.$router.push('/locations/' + this.location.true_id + '/product-imports')
      },
      loadLocationPriceProfiles () {
        if (!this.location || !this.location.true_id) {
          this.locationPriceProfiles = []
          return
        }
        const locationTrueId = this.location.true_id
        this.apiRequest('/price-profiles', 'GET', {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          perPage: 200,
          page: 1
        }, (response) => {
          if (!response || !response.status) {
            this.locationPriceProfiles = []
            return
          }
          const items = response.data || []
          this.locationPriceProfiles = items.filter((profile) => {
            const locs = profile.location_details || profile.locationDetails || []
            return locs.some((loc) => {
              const locId = loc.true_id != null ? loc.true_id : loc.id
              return String(locId) === String(locationTrueId)
            })
          })
          if (this.selectedPriceProfileId) {
            const stillThere = this.locationPriceProfiles.some(p => p.id === this.selectedPriceProfileId)
            if (!stillThere) {
              this.selectedPriceProfileId = null
            }
          }
          if (!this.locationPriceProfiles.length) {
            this.createDefaultPriceProfileForLocation()
          } else if (!this.selectedPriceProfileId) {
            this.selectedPriceProfileId = this.locationPriceProfiles[0].id
          }
        })
      },
      createDefaultPriceProfileForLocation () {
        if (!this.location || !this.location.true_id || this.creatingDefaultPriceProfile) {
          return
        }
        this.creatingDefaultPriceProfile = true
        const locationName = (this.location.name || 'Location').trim()
        const data = {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          name: locationName + ' default',
          location_ids: [this.location.true_id],
          top_category_ids: [],
          delivery_range_ids: [],
          customers_group_ids: [],
          products: [],
          products_to_delete: []
        }
        this.apiRequest('/price-profiles', 'POST', data, (response) => {
          this.creatingDefaultPriceProfile = false
          if (response && response.status) {
            const created = response.data && (Array.isArray(response.data) ? response.data[0] : response.data)
            if (created && created.id) {
              this.locationPriceProfiles = [created]
              this.selectedPriceProfileId = created.id
            } else {
              // Reload list after create
              this.loadLocationPriceProfilesAfterCreate()
            }
          }
        })
      },
      loadLocationPriceProfilesAfterCreate () {
        if (!this.location || !this.location.true_id) {
          return
        }
        const locationTrueId = this.location.true_id
        this.apiRequest('/price-profiles', 'GET', {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          perPage: 200,
          page: 1
        }, (response) => {
          if (!response || !response.status) {
            return
          }
          const items = response.data || []
          this.locationPriceProfiles = items.filter((profile) => {
            const locs = profile.location_details || profile.locationDetails || []
            return locs.some((loc) => {
              const locId = loc.true_id != null ? loc.true_id : loc.id
              return String(locId) === String(locationTrueId)
            })
          })
          if (this.locationPriceProfiles.length && !this.selectedPriceProfileId) {
            this.selectedPriceProfileId = this.locationPriceProfiles[0].id
          }
        })
      },
      loadLocationProductCount () {
        if (!this.location || !this.location.token) {
          this.locationHasProducts = false
          return
        }
        this.apiRequest('/sidemenu-products', 'GET', {
          token: this.$session.get('token'),
          company_id: this.$session.get('selectedCompany'),
          location_ids: [this.location.token],
          page: 1
        }, (response) => {
          if (response && response.status && response.data && response.data.pagination) {
            this.locationHasProducts = (response.data.pagination.totalRecords || 0) > 0
            return
          }
          const rows = response && response.data && response.data.data
          this.locationHasProducts = Array.isArray(rows) && rows.length > 0
        })
      },
      backButton () {
        // this.$session.set('selectedTab', this.$t('settingsPages.companyLocations'))
        // this.router.push('/settings')
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      },
      scrollToSection (sectionId) {
        const innerContainer = document.getElementById('inner-container')
        const targetElement = document.getElementById(sectionId)
        if (innerContainer && targetElement) {
          const offset = -5
          const innerContainerRect = innerContainer.getBoundingClientRect()
          const targetElementRect = targetElement.getBoundingClientRect()

          // Calculate the top position of the target element relative to the inner container
          const elementPosition = targetElementRect.top - innerContainerRect.top + innerContainer.scrollTop + offset
          innerContainer.scrollTo({
            top: elementPosition,
            behavior: 'smooth'
          })
        }
      },
      openSection (section) {
        this.currentSection = section
        if (section === 'menu-actions') {
          this.loadLocationPriceProfiles()
          this.loadLocationProductCount()
        }
      }
    }
  }
</script>
<style scopped>
  .copy_link {
    margin-top: 10px;
    width: 100%;
  }
  .upload-demo input[type="file"]{ display: none; }
  .middle {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  .card-containerf1 {
    display: flex;
    justify-content: space-between;
    gap: 10px;
  }

  .card.location-card {
    flex: 1;
    margin-left: 0px !important;
    margin-right: 0px !important;
  }
  #delivery-methods .disable-chck {
    padding: 18px 10px 0px;
    top: 4px;
    position: relative;
    right: 5px;
  }
  .disable-chck:first-of-type {
    padding-top: 10px !important;
  }
  .flex-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .import-history-btn {
    text-transform: none !important;
    font-weight: 400;
    font-size: 12px;
    border-radius: 50px;
    border: 1px solid transparent;
    box-sizing: border-box;
    height: 32px;
    padding: 4px 12px !important;
    line-height: 1.2;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #E4F4FF;
    color: #0097FC;
  }

  .import-history-btn:hover,
  .import-history-btn:focus {
    background: #E4F4FF;
    color: #0097FC;
    border-color: #0097FC;
  }

  .import-history-btn i {
    margin-right: 5px;
    font-size: 12px;
  }

  .import-step__head {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 10px;
  }

  .import-step__badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #E4E8F9;
    color: #674BD2;
    font-weight: 600;
    font-size: 13px;
    flex-shrink: 0;
  }

  .import-step__body .text-muted {
    font-size: 13px;
    line-height: 1.4;
  }

  .import-step__hint {
    margin: 0 0 12px;
    font-size: 13px;
    line-height: 1.4;
  }

  .import-option {
    padding: 12px;
    border: 1px solid #E6EFFB;
    border-radius: 10px;
    background: #F8FAFF;
    margin-bottom: 12px;
  }

  .import-option--secondary {
    background: #fff;
  }

  .import-option__label {
    font-weight: 600;
    font-size: 13px;
    color: #3C4858;
    margin-bottom: 4px;
  }

  .import-option__desc,
  .import-option__note {
    margin: 0 0 10px;
    font-size: 12px;
    line-height: 1.4;
  }

  .import-option__note {
    margin-top: 8px;
    margin-bottom: 10px;
  }

  .import-step__btn {
    text-transform: none !important;
    font-weight: 400;
    font-size: 14px;
    border-radius: 50px;
    border: 1px solid transparent;
    box-sizing: border-box;
    height: 46px;
    padding: 10px 15px !important;
    line-height: 25px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: #E4F4FF;
    color: #0097FC;
  }

  .import-step__btn:hover,
  .import-step__btn:focus {
    background: #E4F4FF;
    color: #0097FC;
    border-color: #0097FC;
  }

  .import-step__btn:disabled,
  .import-step__btn[disabled] {
    opacity: 0.55;
    cursor: not-allowed;
    border-color: transparent;
  }

  @media (min-width: 992px) {
    .import-steps > .import-step:not(:last-child) {
      border-right: 1px solid #E6EFFB;
    }
  }

  .space-between {
    display: flex;
    justify-content: space-between;
  }

  .break-word {
    word-break: break-word;
  }

  .max-z-index {
    z-index: 999;
  }
  .datetime-picker .el-date-editor {
    width: 180px !important;
    min-width: 180px !important;
  }

  .location-vat-table {
    table-layout: fixed;
  }

  .location-vat-table thead th.location-vat-th {
    vertical-align: middle;
  }

  .location-vat-table thead th .location-vat-th-inner {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 34px;
    width: 100%;
    text-align: center;
  }

  .location-vat-table thead th.location-vat-th-icon {
    width: 52px;
  }

  .location-vat-table tbody td {
    vertical-align: top;
  }

  .vat-printer-td {
    overflow: visible;
  }

  .vat-printer-input-wrap {
    position: relative;
  }

  .vat-printer-error-abs {
    position: absolute;
    left: 45px;
    top: 100%;
    margin-top: 4px;
    right: 0;
    padding-left: 10px;
    z-index: 2;
    white-space: nowrap;
  }

  .vat-printer-error-abs .vat-printer-error {
    display: block;
    margin: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Settings/Locations/LocationForm.vue